// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-container {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 81vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #f5f5f5;
  position: relative;
  box-shadow: 0px -2px 15px 0px rgba(0, 0, 0, 0.14);
}

.bg-container .highlight {
  color: #d2042d;
  font-weight: bold;
}

.section-partition {
  color: #fff;
  text-align: center;
  font-size: 23px;
  font-weight: 600;
  font-family: Roboto;
}

.home-calendar {
  background-color: #fff;
  height: 80px;
  display: inline-flex;
  align-items: center;
  padding-right: 0rem;
}

.home-text {
  color: #5b5e5d;
  font-weight: 600;
}

.dma-select-btn {
  min-width: 22vw;
  width: auto !important;
  text-align: left !important;
}

.bg-description {
  font-family: Roboto;
  font-size: 1.2rem;
  color: #000;
  /* text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */
  /* text-align: center; */
  font-weight: 500;
  margin-top: 10px;
  max-width: 80% !important;
}

.dropdown-btn.ant-select-single .ant-select-selector {
  font-size: 19px;
  color: #757575;
  cursor: pointer !important;
}

.search-btn
  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
  background-color: #d2042d !important;
  border-color: none;
}

.ant-picker-range .ant-picker-active-bar {
  bottom: -1px;
  height: 2px;
  background: #d2042d;
  opacity: 0;
  transition: all 0.3s ease-out;
  pointer-events: none;
}

.ant-btn:not(:disabled):focus-visible {
  outline: 3px solid #d2042d;
  outline-offset: 1px;
  transition:
    outline-offset 0s,
    outline 0s;
}

.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  border: none !important;
  background: #ffffff;
}

.ant-select-multiple .ant-select-selection-placeholder {
  position: absolute;
  top: 50%;
  inset-inline-start: 11px;
  inset-inline-end: 11px;
  transform: translateY(-50%);
  transition: all 0.3s;
  font-size: 14px;
  color: #757575 !important;
}

.ant-select-dropdown .ant-select-item-option-content {
  font-family: Roboto;
  font-size: 14px !important;
}

.ant-select-selection-item-remove {
  display: none !important;
}

.ant-select-multiple
  .ant-select-selection-overflow
  .ant-select-selection-item-content {
  font-size: 19px !important;
}

.ant-select-outlined.ant-select-multiple .ant-select-selection-item {
  background-color: unset !important;
  color: #757575 !important;
  border: none !important;
}

.ant-select-dropdown
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: unset !important;
}

.dropdown-btn.ant-select-single.ant-select-show-arrow
  .ant-select-selection-item {
  font-size: 14px !important;
  font-family: Roboto !important;
  font-weight: 400 !important;
}

.dropdown-btn.ant-select-single.ant-select-show-arrow
  .ant-select-selection-placeholder {
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.ant-picker-range-separator {
  display: none !important;
}

.ant-select-multiple .ant-select-selection-wrap {
  align-self: center;
}

.dropdown-btn {
  width: 9.8vw;
  height: 80px;
  color: #757575;
  font-weight: 600;
  font-size: 19px;
  margin-left: -3px;
}

.search-btn {
  font-family: Roboto;
  background-color: #d2042d;
  color: #fff;
  border: 1px #d2042d solid;
  height: 80px;
  font-size: 20px;
  width: 11.81vw;
}

.search-btn:active {
  background-color: #d2042d !important;
  color: #fff !important;
  border: none !important;
}

.search-btn:hover {
  background-color: #d2042d !important;
  color: #fff !important;
  border: 1px #d2042d solid !important;
}

.home-cont {
  /* background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0)); */
  border-radius: 12px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent !important;
}

.home-cont-title {
  color: #fff !important;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  font-family: "Roboto";
  font-size: 32px !important;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  text-align: center;
}

.home-updated-title-color {
  color: #000 !important;
}

.dropdown-btn:hover {
  color: #757575 !important;
  border-color: #ccc !important;
}

.dropdown-btn:active {
  color: #757575 !important;

  border-color: #ccc !important;
}

.top-billboards {
  color: #fff;
  font-size: 1.05rem;
  text-overflow: ellipsis;
}

.home_input_search {
  width: 22.86vw;
  height: 80px;
  padding-left: 2vw;
  width: 100% !important;
}

.home_input_search .ant-input-prefix {
  margin-right: 1rem;
}

.home_input_search .ant-input {
  color: #757575 !important;
  font-family: Roboto;
  font-size: 18px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.home_input_search:hover {
  border: 1px solid #ccc !important;
  border: none !important;
}

.home_input_search::placeholder {
  font-size: 19px;
  color: #757575;
}

.home-calendar::placeholder {
  color: #757575;
}

.faq-collapse .ant-collapse-content > .ant-collapse-content-box {
  padding: 16px 30px;
}

.ant-input-group.ant-input-group-compact > *:first-child {
  border-start-start-radius: 20px !important;
  border-end-start-radius: 20px !important;
  cursor: pointer;
  font-family: Roboto !important;
}

.ant-input-group.ant-input-group-compact > *:last-child {
  border-start-end-radius: 20px !important;
  border-end-end-radius: 20px !important;
}

.input-group {
  margin-top: 6px;
  width: 90%;
  height: 100px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
}

.special-style-class {
  width: 100% !important;
}

.ant-layout-header {
  padding: 0 50px;
}

.booking-text {
  background: #fff;
  height: 46px;
  width: 288px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.09);
  margin-top: 18px;
  border-radius: 5px;
  gap: 8px;
}

footer {
  background-color: #ff4d4f;
}

footer .ant-row {
  justify-content: center;
}

.hero-section-search-btn:hover {
  background-color: #d2042d !important;
}

/* Mobile specific styling */
@media (max-width: 567px) {
  .ant-layout-header {
    padding: 0 20px;
  }

  .mobile-card {
    width: 90%;
    height: 69%;
    margin-top: 8%;
  }

  .hero-section-search-btn {
    color: #fff;
    background-color: #d2042d;
    height: 60px;
    border: "none";
  }

  .hero-section-search-btn :hover {
    background-color: #d2042d !important;
    color: #fff !important;
    box-shadow: none !important;
    border: none !important;
    cursor: pointer;
  }

  .create-accont-btn-signup.ant-btn-primary:hover {
    background-color: #d2042d !important;
    color: #fff !important;
    box-shadow: none !important;
    border: none !important;
    cursor: pointer;
  }

  .ant-input-group {
    flex-direction: column;
  }

  footer .ant-row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  footer .ant-tag {
    font-size: 14px;
    margin: 5px;
  }
}

.red-bg {
  background-color: #d2042d;
  padding: 20px 0px;
}

.home-container {
  padding: 0 16px;
  max-width: 100%;
}

.desktop-view {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  overflow: hidden;
}

.desktop-item-title {
  cursor: pointer;
}

.carousel-mobile .carousel-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-content h5 {
  color: #ffffff;
}

.carousel-item-title {
  font-size: 18px;
  margin-left: 0.8rem;
}

.title {
  font-size: 2.95rem !important;
  color: white;
}

.desktop-view img {
  margin-right: 8px;
}

.desktop-view .ant-typography {
  color: #ffffff;
  margin-top: 1rem;
  font-size: var(--Font-Font-Size-h5, 23px) !important;
  font-style: normal;
  font-weight: 700;
  line-height: 33.6px;
  font-family: Roboto;
}

.ant-container {
  max-width: 1550px;
  margin: 0 auto;
  padding: 0 15px;
}

.responsive-gap {
  padding: 2rem 0;
}

.responsive-text-container {
  text-align: center;
  padding: 16px;
}

.how-it-works-title.ant-typography {
  margin-bottom: 0px !important;
  font-family: "Roboto";
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h1, 48px);
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  padding-top: 0px;
}

.how-it-works-title span {
  color: #d2042d;
}

.subtitle-text.ant-typography {
  font-family: Roboto;
  margin-top: 1px !important;
  font-weight: 500 !important;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h5, 23px);
  font-style: normal;
  font-weight: 500;
  line-height: 34.5px;
}

.theme-red span {
  border-bottom: 4px solid #d2042d;
}

.signup-text strong {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h5, 1.4375rem);
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.cardtext-para2 {
  color: #000;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h6, 1.1875rem);
  font-style: normal;
  font-weight: 400;
  line-height: 1.78125rem;
  margin-top: 10px;
  flex-direction: row;
  flex-wrap: nowrap;
}

.custom-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 260px;
  width: 100%;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  text-align: left;
}

.service-card-wrapper {
  position: relative;
}

.custom-service-card {
  clip-path: polygon(
    0 0,
    100% 0,
    100% 100%,
    0 100%,

    /* Start of curve at bottom of vertical cut */ 0 90px,

    /* Start higher for curve space */ /* Bottom curve points (simulated) */ 5px
      85px,
    10px 82px,
    15px 81px,
    20px 80px,

    /* Horizontal line */ 75px 80px,

    /* Shorter to account for curve */ /* Top curve points */ 78px 75px,
    79px 70px,
    80px 65px,
    80px 60px,

    /* Vertical line up */ 80px 5px,

    /* Back to start with slight curve */ 75px 2px,
    70px 1px,
    65px 0,
    0 0
  );
}

.service-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 80px;
}

.scrollable-container {
  display: flex;
}

.scrollable-container .ant-col {
  display: flex;
  justify-content: stretch;
}

.scrollable-container::-webkit-scrollbar {
  display: none;
}

.buyer-seller-card {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin: 0 auto;
}

.card-icon-container {
  margin-bottom: 16px;
}

.circle-border {
  background-color: #d7a7b099;
  display: inline-block;
  border: 2px solid #e0e0e0;
  border-radius: 50%;
  padding: 15px;
}

.card-icon {
  width: 50px;
  height: 50px;
}

.card-title {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 500;
  color: #8e9190;
  word-wrap: break-word;
  margin-bottom: 10px;
}

.card-header strong {
  font-size: 18px;
  color: #0a0f0d;
  font-weight: 900;
  word-wrap: break-word;
  margin-bottom: 8px;
}

.card-list {
  margin-top: 1rem;
  flex-grow: 1;
  padding-left: 1em;
  height: auto;
}

.marketplace-card-list-text {
  position: relative;
  color: #000000;
  font-family: Roboto;
  font-size: 19px;
  font-weight: 400;
  text-align: left;
}

.card-list-item {
  padding: 5px 0 !important;
  font-size: 19px;
  line-height: 1.5;
  color: black;
  list-style: disc;
  font-weight: 400 !important;
  font-family: "Roboto" !important;
}

.card-list-item strong {
  position: relative;
  color: #000000;
  font-family: Roboto;
  font-size: 19px;
  font-weight: 700;
  text-align: left;
}

.footer-title {
  font-family: Roboto;
  margin-top: 16px;
  color: #0a0f0d;
  font-weight: bold;
}

.footer-link {
  margin-top: 16px;
  color: #d2042d;
  font-size: 19px;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  text-decoration: underline;
  line-height: 25.6px;
  display: block;
}

.footer-link-text {
  color: #d2042d;
  font-size: 19px;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  text-decoration: underline;
  line-height: 25.6px;
  display: block;
}

/* Marketplace.css */
.marketplace-card {
  width: 100%;
  height: 100%;
  position: relative;
  background: white;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05) !important;
  border-radius: 10px;
  overflow: hidden;
}

.marketplace-card img {
  width: 90% !important;
}

.marketplace-card .image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 45%;
}

.video-card-alignment {
  padding-bottom: 30px !important;
  padding-top: 30px !important;
}

.jack-video-calendar {
  font-size: 19px;
  font-weight: 400;
  font-family: Roboto;
  color: #d2042d;
}

.video-caption-text {
  gap: 30px;
}

.marketplace-card .video-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.marketplace-card img {
  width: 100% !important;
  height: 100% !important;
}

.marketplace-card .signup-text {
  font-weight: bold;
}

.marketplace-card .benefits-list {
  padding-left: 1em;
  margin-top: 1.5rem;
}

.marketplace-card .benefits-list li {
  margin-bottom: 10px;
}

.marketplace-card .create-account-btn {
  color: white;
  font-size: 19px;
  font-weight: 400;
  word-wrap: break-word;
  background-color: #d2042d;
  border: none;
  text-align: center;
  border-radius: 4px;
  margin-top: 20px;

  padding: 20px 10px;
}

.create-account-btn:hover {
  background-color: #d2042d !important;
  color: #fff !important;
  border: none !important;
  cursor: pointer;
}

/* Locations.css */

.location-item .ant-card-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.location-item img {
  width: 307px;
  height: 336px;
  border-radius: 8px;
}

.locations {
  overflow: hidden;
}

.location-title {
  text-align: center;
  margin-top: 10px;
}

.location {
  cursor: pointer;
}

.location-title-name.ant-typography {
  color: #000;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h4, 23px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.location-title-name.ant-typography:hover {
  color: #d2042d;
}

.home-page-buttons-section {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: flex-start;
  gap: 15px !important;
  align-items: center;
}

.create-accont-btn-signup.ant-btn-primary {
  margin-top: 3.5em;
  font-weight: 500;
  color: #fff;
  background-color: #d2042d;
  border-radius: 0.3125rem;
  padding: 20px 20px;
  font-size: 16px;
  height: 60px !important;
  width: 228px !important;
  transition: none !important;
}

.request-for-demo.ant-btn-variant-outlined {
  font-family: Roboto;
  margin-top: 3.5rem !important;
  font-weight: 500;
  color: #000 !important;
  background-color: #f0f0f0 !important;
  padding: 20px 20px;
  font-size: 16px;
  height: 60px !important;
  border-radius: #f0f0f0 !important;
  border-color: #f0f0f0 !important;
  width: 228px !important;
}

.request-for-demo.ant-btn-variant-outlined:hover {
  color: #000 !important;
  background-color: #f0f0f0 !important;
  border-radius: #f0f0f0 !important;
  border-color: #f0f0f0 !important;
}

.create-accont-btn-signup.ant-btn-primary:hover {
  cursor: pointer;
}

.create-accont-btn-signup .ant-btn-primary:active {
  background-color: #d2042d !important;
  color: #fff !important;
  box-shadow: none !important;
  border: none !important;
  cursor: pointer;
  border-radius: 0.3125rem;
}

.faq-collapse {
  border: none;
  background-color: #f5f5f5;
}

.faq-collapse-section {
  margin-top: 35px;
}

.faq-collapse p {
  padding-left: 2rem;
}

.faq-collapse .ant-collapse-header {
  color: #000;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h5, 1.4375rem);
  font-style: normal;
  font-weight: 700;
  line-height: 2.15625rem;
}

.faq-collapse .ant-collapse-content {
  font-size: 19px;
  border: none;
  border-radius: 10px;
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: 1.1875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.78125rem;
}

.faq-collapse .ant-collapse-item {
  border: none !important;
  border-radius: 10px;
  margin-bottom: 2rem;
}

.ant-collapse-expand-icon {
  display: inline !important;
}

.faq-collapse .ant-collapse-item-active .ant-collapse-header {
  background-color: white !important;
  border-radius: 10px 10px 0px 0px !important;
}

.faq-collapse .ant-collapse-item-active {
  background-color: white !important;
  box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.05);
}

.visit-help-center-btn {
  cursor: pointer;
  display: inline-flex;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d);
  height: 60px !important;
}

.visit-help-center-btn.ant-btn-primary:hover {
  background: var(--Colors-Primary-500, #d2042d);
}

.visit-help-center-text {
  color: #fff;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 600;
  line-height: 25.6px;
}

.marketplace-card .image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 45% !important;
  height: 480px !important;
}

.advertisement-link-faq {
  color: var(--Colors-Text-500, #0a0f0d) !important;
  font-family: Roboto;
  font-size: 19px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 28.5px;
  text-decoration: underline !important;
}

.advertisement-link-faq:hover {
  color: #d2042d !important;
  text-decoration: underline !important;
}

.faq-answer-test.ant-typography {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: 1.1875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.78125rem;
}

.marketplace-card-row {
  display: flex;
  width: 100%;
  gap: 5%;
}

.image-container-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.content-container-css {
  padding: 15px 50px 0px 0px;
  width: 50%;
}

.top-cities-row-home {
  display: flex;
  margin-right: -30px !important;
  flex-wrap: nowrap;
}

.marketplace-card.ant-card .ant-card-body {
  padding: 40px !important;
}

.tooltip-seller-restriction {
  font-family: Roboto;
  font-size: 14px !important;
}

/* ========================================================
   1. VIDEO HERO SECTION
   ======================================================== */

/* --- Base Desktop Styles --- */
.video-hero-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.video-hero-container video {
  width: 100%;
  height: auto;
  display: block;
}

.video-hero-content {
  position: absolute;
  top: 50%;
  left: 12%;
  width: 60%;
  transform: translateY(-50%);
  z-index: 10;
  color: #fff;
}

.video-hero-badge {
  display: inline-block;
  padding: 7px 14px;
  margin-bottom: 20px;
  border-radius: 100px;
  background: #adaaaa80;
  font-size: 12px;
  letter-spacing: 0.5px;
  padding-left: 12px;
  gap: 4px;
}

.video-hero-dot {
  color: #d2042d;
}

.video-hero-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  color: #ffffff;
}

/* Hero heading (now a <Text>, so it must be display:block) */
.home_main_heading {
  display: block;
  margin: 0 0 15px;
  font-family: Roboto;
  font-weight: 800;
  font-style: ExtraBold;
  font-size: 48px;
  line-height: 1.15;
  letter-spacing: -0.5px;
  color: #fff;
  text-transform: uppercase;
}

.home_main_heading span {
  color: #ed0b3b;
}

.home_main_paragraph,
.video-hero-content p {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 20px;
  line-height: 1.5;
  color: #e5e7eb;
  margin-bottom: 20px;
}

.video-hero-select-text {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  color: #ffffff;
  margin-bottom: 16px;
  font-weight: 400;
}

.video-hero-buttons {
  display: flex;
  gap: 14px;
  align-items: center;
  flex-wrap: wrap;
}

.video-hero-btn-primary {
  border: none;
  background: #d2042d;
  color: #fff;
  padding: 14px 30px;
  cursor: pointer;
  border-radius: 5px;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  transition:
    background 0.2s ease,
    transform 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.video-hero-btn-primary:hover {
  background: #b50326;
  transform: translateY(-1px);
}

.video-hero-btn-outline {
  border: 1px solid rgba(255, 255, 255, 0.65);
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  color: #fff;
  padding: 13px 26px;
  cursor: pointer;
  border-radius: 5px;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 15px;
  text-align: center;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.video-hero-btn-outline:hover {
  border-color: #ffffff;
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
}

/* --- Video Hero: Tablet (max-width: 1024px) --- */
@media (max-width: 1024px) {
  .video-hero-content {
    left: 8% !important;
    width: 75% !important;
  }

  .home_main_heading {
    font-size: 34px !important;
  }

  .home_main_paragraph,
  .video-hero-content p {
    font-size: 16px !important;
  }
}

/* --- Video Hero: Mobile / Tablet (max-width: 768px) --- */
@media (max-width: 768px) {
  .video-hero-container {
    min-height: 560px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .video-hero-container video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .video-hero-content {
    position: relative !important;
    top: unset !important;
    left: unset !important;
    transform: none !important;
    width: 90% !important;
    max-width: 600px !important;
    margin: 0 auto !important;
    padding: 40px 0 !important;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .video-hero-badge {
    margin-bottom: 14px !important;
    padding: 5px 12px !important;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .video-hero-text {
    font-size: 13px !important;
  }

  .home_main_heading {
    font-size: 32px !important;
    line-height: 1.25 !important;
    margin-bottom: 14px !important;
  }

  .home_main_paragraph,
  .video-hero-content p {
    font-size: 16px !important;
    line-height: 1.55 !important;
    margin-bottom: 16px !important;
  }

  .video-hero-select-text {
    font-size: 16px !important;
    margin-bottom: 12px !important;
  }

  .video-hero-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .video-hero-btn-primary,
  .video-hero-btn-outline {
    width: 100%;
    height: 48px;
    padding: 12px 16px !important;
    font-size: 16px !important;
  }
}

/* --- Video Hero: Small Mobile Phones (max-width: 480px) --- */
@media (max-width: 480px) {
  .video-hero-container {
    min-height: 600px;
  }

  .home_main_heading {
    font-size: 24px !important;
    line-height: 1.2 !important;
  }

  .video-hero-buttons {
    flex-direction: column;
    gap: 10px;
  }

  .video-hero-btn-primary,
  .video-hero-btn-outline {
    width: 100%;
    height: 48px;
  }
}

/* ========================================================
   2. RED STAT BANNER
   ======================================================== */

/* --- Base Desktop Styles --- */
.Add-banner-alert {
  width: 100% !important;
  background-color: var(--Colors-Primary-500, #d2042d);
  border-radius: 0%;
}

.banner-content {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 20px;
  margin-top: 35px;
  margin-bottom: 34px;
  flex-wrap: wrap;
}

.banner-content-span {
  font-family: Roboto;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
}

/* --- Red Stat Banner: Tablet (max-width: 1024px) --- */
@media (max-width: 1024px) {
  .banner-content-span {
    font-size: 18px;
  }
}

/* --- Red Stat Banner: Tablet & Mobile (max-width: 768px) --- */
@media (max-width: 768px) {
  .banner-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 90%;
    margin: 20px auto;
    gap: 16px;
    flex-wrap: wrap;
  }

  .banner-content-span {
    font-size: 16px !important;
  }
}

/* --- Red Stat Banner: Small Mobile (max-width: 480px) --- */
@media (max-width: 480px) {
  .banner-content-span {
    font-size: 13px;
  }
}

/* ========================================================
   3. WHAT IS ADVERTISING MARKETPLACE
   ======================================================== */

/* --- Base Desktop Styles --- */
.advertising-marketplace-section {
  padding: 70px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.advertising-content-main {
  width: 75%;
  margin: 60px auto 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4%;
  flex-direction: row;
  box-sizing: border-box;
}

.advertising-content-new {
  flex: 0 0 48%;
  width: 48%;
  min-width: 0;
}

/* Both <Text> items are direct children: 1st = heading, 2nd = paragraph */
.advertising-content-new > .ant-typography {
  display: block;
  font-family: Roboto;
}

.advertising-content-new > .ant-typography:first-child {
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 48px;
  line-height: 1.15;
  color: #0a0a0a;
}

.advertising-content-new > .ant-typography:first-child span {
  color: #d2042d;
}

.advertising-content-new > .ant-typography:nth-child(2) {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: #444;
}

.marketplace-features {
  display: flex;
  gap: 12px;
  margin-top: 28px;
}

.feature-card {
  flex: 1 1;
  min-width: 0;
  min-height: 105px;
  padding: 14px;
  border: 1px solid #f3f4f6;
  border-radius: 14px;
  box-sizing: border-box;
  background-color: #f9fafb;
}

.feature-icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 8px;
  background: #fff0f3;
  color: #d50032;
  font-size: 18px;
}

/* Title is a <Text> inside .feature-card */
.feature-card .ant-typography {
  display: block;
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #222;
}

.feature-card span {
  display: block;
  font-size: 12px;
  line-height: 1.4;
  color: #777;
}

.advertising-main-img,
.advertising-content-main > img {
  flex: 0 0 48%;
  width: 48%;
  max-width: 48%;
  height: auto;
  object-fit: cover;
  border-radius: 20px;
  display: block;
}

.advertising-image {
  width: 43%;
}

.advertising-image img {
  display: block;
  width: 100%;
  height: 310px;
  object-fit: cover;
  border-radius: 22px;
}

/* --- Advertising Marketplace: Tablet (max-width: 1024px) --- */
@media (max-width: 1024px) {
  .advertising-content-main {
    width: 84%;
    margin: 40px auto 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 4%;
    box-sizing: border-box;
  }

  .advertising-content-new {
    flex: 0 0 48%;
    width: 48%;
    min-width: 0;
  }

  .advertising-main-img,
  .advertising-content-main > img {
    flex: 0 0 48%;
    width: 48%;
    max-width: 48%;
    height: auto;
    object-fit: cover;
    border-radius: 20px;
    display: block;
  }

  .advertising-content-new > .ant-typography:first-child {
    font-size: 38px;
  }
}

/* --- Advertising Marketplace: Mobile & Tablet (max-width: 768px) --- */
@media (max-width: 768px) {
  .advertising-content-main {
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 28px;
    margin: 36px auto;
  }

  .advertising-content-new {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .advertising-content-new > .ant-typography:first-child {
    font-size: 32px !important;
    line-height: 1.2 !important;
    margin-bottom: 6px;
  }

  .advertising-content-new > .ant-typography:nth-child(2),
  .advertising-content-new > .ant-typography {
    font-size: 16px !important;
    line-height: 1.6;
  }

  .advertising-main-img,
  .advertising-content-main > img {
    width: 100%;
    max-width: 500px;
    height: auto;
    object-fit: cover;
    border-radius: 16px;
    display: block;
  }

  .marketplace-features {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin-top: 16px;
  }

  .feature-card {
    width: 100% !important;
    padding: 14px 16px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .feature-card .ant-typography {
    font-size: 19px !important;
    font-weight: 600;
    margin: 0 0 4px 0;
  }

  .feature-card span {
    font-size: 13px !important;
  }
}

/* --- Advertising Marketplace: Small Mobile (max-width: 480px) --- */
@media (max-width: 480px) {
  .advertising-content-new > .ant-typography:first-child {
    font-size: 26px !important;
  }

  .advertising-main-img,
  .advertising-content-main > img {
    width: 100% !important;
    max-height: 220px;
    border-radius: 14px;
  }
}

/* ========================================================
   EXISTING RESPONSIVE / MEDIA QUERIES
   ======================================================== */
/* Responsive Media Queries */
@media (max-width: 1024px) {
  /* Tablet View */
  .desktop-view > h5 {
    font-size: 14px;
  }

  .popular-search {
    margin-top: 1vh;
    width: 100%;
    margin-left: -3vh !important;
    padding-left: 20px;
  }

  .dma-filter-cont {
    margin-left: 1% !important;
  }

  .ant-select-multiple .ant-select-selection-placeholder {
    position: absolute;
    top: 50%;
    inset-inline-start: 11px;
    inset-inline-end: 11px;
    transform: translateY(-50%);
    transition: all 0.3s;
    font-size: 16px;
    color: #757575 !important;
  }

  .ant-select-dropdown .ant-select-item-option-content {
    font-size: 16px !important;
  }

  .ant-select-selection-item-remove {
    display: none !important;
  }

  .desktop-view .ant-typography {
    font-size: 16px !important;
  }

  .ant-select-outlined.ant-select-multiple .ant-select-selection-item {
    background-color: unset !important;
    color: #757575 !important;
    border: none !important;
  }

  .ant-select-dropdown
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: unset !important;
  }

  .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
    font-size: 16px;
    color: #757575;
  }

  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    font-size: 15px !important;
    color: #757575 !important;
  }

  .dropdown-btn {
    font-family: Roboto;
    width: 16vw;
    height: 90px;
    color: #757575;
    font-weight: 600;
    font-size: 16px;
    margin-left: -3px;
  }

  .search-btn {
    font-family: Roboto;
    background-color: #d2042d;
    color: #fff;
    border: 1px #d2042d solid;
    height: 90px !important;
    font-size: 17px;
    width: 13.81vw;
  }

  .home-calendar {
    background-color: #fff;
    height: 90px;
    display: inline-flex;
    align-items: center;
    padding-right: 1rem;
    width: 200px;
  }

  .home_input_search {
    height: 90px;
    padding-left: 2vw;
  }

  .home_input_search::placeholder {
    font-size: 16px;
    color: #757575;
  }

  .home-cont-title {
    /* color: #fff !important; */
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-family: "Roboto";
    font-size: 40px !important;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    text-align: center;
  }

  .bg-description {
    font-size: 18px;
    /* color: #fff; */
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    text-align: center;
  }

  .how-it-works-title.ant-typography {
    margin-bottom: 0px !important;
    font-family: "Roboto";
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h1, 40px);
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    padding-top: 0px;
  }

  .subtitle-text.ant-typography {
    margin-top: 1px !important;
    font-weight: 500 !important;
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h5, 20px);
    font-style: normal;
    font-weight: 500;
    line-height: 34.5px;
  }

  .theme-red.ant-typography {
    font-size: 3rem !important;
  }

  .signup-text strong {
    font-size: var(--Font-Font-Size-h5, 1.2375rem) !important;
  }

  .cardtext-para2 {
    font-size: var(--Font-Font-Size-h6, 19px);
  }

  .benefits-signup-text.ant-typography {
    height: 18px !important;
    font-size: 22px !important;
  }

  .marketplace-card-list-text {
    font-size: 18px !important;
  }

  .marketplace-card .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 45% !important;
    height: 480px !important;
  }

  .marketplace-card .video-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 480px !important;
  }

  .marketplace-card img {
    width: 100% !important;
    height: 100% !important;
  }

  .price strong {
    font-size: var(--Font-Font-Size-h2, 2.2rem) !important;
  }

  .location-title-name.ant-typography {
    font-size: var(--Font-Font-Size-h4, 22px) !important;
  }

  .faq-collapse .ant-collapse-header {
    font-size: var(--Font-Font-Size-h5, 1.2375rem) !important;
  }

  .faq-answer-test.ant-typography {
    font-size: 18px !important;
  }

  .benefits-signup-text.ant-typography {
    height: 16px !important;
    font-size: 22px !important;
  }

  .card-list-item strong {
    font-size: 19px !important;
  }

  .location-item img {
    width: 225px !important;
    height: 320px !important;
    border-radius: 8px;
  }
}

/* Mobile specific styling */
@media (max-width: 768px) {
  .desktop-view .ant-typography {
    font-size: 15px !important;
  }

  .video-card-alignment {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
  }

  .mobile-card {
    width: 90%;
    height: auto;
    max-height: 85%;
    margin-top: 0%;
    text-align: center;
  }

  .hero-secrion-input-group {
    display: flex;
    gap: 6px;
    margin-top: 1rem;
  }

  .hero-section-search-btn {
    color: #fff;
    background-color: #d2042d;
    height: 50px;
    border: "none";
  }

  .hero-section-search-btn :hover {
    background-color: #d2042d !important;
  }

  .ant-layout-header {
    padding: 0 20px;
  }

  .campaign-description {
    font-family: Roboto;
    font-weight: 400;
    line-height: 2;
    font-size: 16px !important;
  }

  .ant-input-group {
    flex-direction: column;
  }

  footer .ant-row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  footer .ant-tag {
    font-size: 14px;
    margin: 5px;
  }

  .cardtext-para2 {
    font-size: 18px !important;
  }

  .title {
    font-size: 2rem !important;
  }

  .location-item img {
    width: 165px !important;
    height: 250px !important;
    border-radius: 8px;
  }

  .location-title-name.ant-typography {
    font-size: var(--Font-Font-Size-h4, 18px) !important;
  }

  .top-cities-row-home {
    /* width: 100% !important; */
    margin-left: 0px !important;
    flex-wrap: wrap !important;
  }

  .dma-select-btn {
    min-width: 82% !important;
    width: auto !important;
    text-align: left !important;
  }
}

.layout {
  position: relative;
}

@media (min-width: 769px) {
  .responsive-text {
    font-size: 1.5rem;
  }
}

@media (max-width: 768px) {
  .scrollable-container {
    justify-content: center;
  }

  .desktop-view img {
    margin-right: 8px;
    width: 25px !important;
  }

  .theme-red.ant-typography {
    font-size: 2.5rem !important;
  }

  .signup-text strong {
    font-size: 18px !important;
  }

  .buyers-reach-description-text {
    font-size: 17px !important;
  }

  .benefits-signup-text.ant-typography {
    height: 16px !important;
    font-size: 20px !important;
  }

  .marketplace-card img {
    width: 100% !important;
    height: 80% !important;
  }

  .create-accont-btn-signup.ant-btn-primary {
    margin-top: 2rem !important;
    background-color: #d2042d;
    font-size: 16px !important;
    height: 52px !important;
    transition: none !important;
  }

  .request-for-demo.ant-btn-variant-outlined {
    margin-top: 2rem !important;
    font-size: 16px !important;
    height: 52px !important;
    transition: none !important;
  }

  .how-it-works-title.ant-typography {
    margin-bottom: 0px !important;
    font-size: var(--Font-Font-Size-h1, 32px) !important;
  }

  .visit-help-center-text {
    font-size: var(--Font-Font-Size-h6, 18px) !important;
  }
}

@media (max-width: 768px) {
  .desktop-view > h5 {
    font-size: 12px;
  }

  .scrollable-card {
    margin: 10px 0;
  }

  .custom-card {
    min-height: 280px;
  }

  .scrollable-container {
    display: flex;
    overflow-x: auto;
    justify-content: start;
    max-width: 100%;
  }

  .responsive-gap {
    padding: 1rem 0;
  }

  .faq-collapse .ant-collapse-header {
    font-size: var(--Font-Font-Size-h5, 1.4rem) !important;
  }

  .faq-answer-test.ant-typography {
    font-size: 1.2rem !important;
  }

  .custom-card.ant-card .ant-card-body {
    padding: 0px !important;
  }

  .create-accont-btn-signup.ant-btn-primary {
    margin-top: 3.5em;
    font-weight: 500;
    color: #fff;
    background-color: #d2042d;
    padding: 20px 20px;
    font-size: 14px !important;
    height: 50px !important;
    width: 55% !important;
    font-weight: 600 !important;
  }

  .request-for-demo.ant-btn-variant-outlined {
    margin-top: 2rem !important;
    font-size: 14px !important;
    height: 52px !important;
    transition: none !important;
    width: 55%;
    font-weight: 600 !important;
  }
}

@media (max-width: 576px) {
  .how-it-works-title {
    font-size: 24px !important;
    word-break: break-word;
    line-height: 1.3;
  }

  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panels {
    display: unset;
    flex-wrap: nowrap;
  }

  .home-page-calendar-component .ant-picker-dropdown-range {
    inset: -500px auto auto -19px !important;
  }

  .subtitle-text {
    font-size: 20px !important;
  }

  .card-header,
  .card-title {
    font-size: 16px;
    line-height: 1.2;
  }

  .card-list-item {
    font-size: 16px;
  }

  .card-list-item strong {
    /* display: inline-block; */
    margin-right: 4px;
    font-size: 16px;
  }

  .marketplace-card img {
    width: 100% !important;
  }

  .marketplace-card .create-account-btn {
    width: 100%;
    padding: 25px;
  }

  .ant-container {
    margin: 0 !important;
  }
}

@media (max-width: 480px) {
  .mobile-card {
    width: 90%;
    height: auto;
    max-height: 81%;
    margin-top: 11%;
    padding-bottom: 5%;
  }

  .custom-card {
    min-height: 280px;
  }
}

@media (max-width: 425px) {
  .mobile-card {
    width: 90%;
    height: auto;
    max-height: 95%;
    margin-top: 11%;
  }

  .custom-card {
    min-height: 280px;
  }

  .marketplace-card .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100% !important;
    height: 325px !important;
    width: 100% !important;
  }

  .image-container {
    padding-left: 15 !important;
    padding-right: 0 !important;
  }

  .content-container {
    padding: 20px 0px 0px 10px !important;
  }

  .title {
    display: flex;
    font-size: 2rem !important;
    justify-content: center !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  .create-accont-btn-signup.ant-btn-primary {
    display: flex;
    margin-top: 0rem !important;
    font-weight: 500;
    color: #fff;
    background-color: #d2042d;
    padding: 20px 20px;
    font-size: 16px;
    height: 45px !important;
    text-align: center !important;
    justify-content: center !important;
    margin-left: 0rem !important;
    width: 45% !important;
    font-size: 14px !important;
  }

  .request-for-demo.ant-btn-variant-outlined {
    margin-top: 0rem !important;
    font-size: 14px !important;
    height: 45px !important;
    transition: none !important;
    width: 45% !important;
    font-weight: 600 !important;
  }

  .top-cities-row-home {
    width: 100% !important;
    margin-left: 0px !important;
    flex-wrap: wrap !important;
  }

  .location-item {
    width: 50% !important;
  }

  .location-item img {
    width: 100% !important;
    height: auto !important;

    border-radius: 8px;
  }

  .faq-collapse .ant-collapse-header {
    font-size: var(--Font-Font-Size-h5, 1rem) !important;
  }

  .faq-answer-test.ant-typography {
    font-size: 16px !important;
  }

  .visit-help-center-btn {
    height: 50px !important;
  }

  .visit-help-center-text {
    font-size: var(--Font-Font-Size-h6, 16px) !important;
  }

  .custom-card.ant-card .ant-card-body {
    padding: 0px !important;
  }

  .enquiry-billboard-chat-div-mobile {
    height: 60px !important;
    width: 60px !important;
    background-color: #fff;
    border-top-left-radius: 40px;
    border-bottom-left-radius: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 50%;
    margin-right: 2%;
  }
}

@media (max-width: 400px) {
  .mobile-card {
    width: 90%;
    height: auto;
    max-height: 100%;
    margin-top: 19%;
  }

  .custom-card {
    min-height: 280px;
  }
}

@media (max-width: 360px) {
  .hero-section-search-btn {
    color: #fff;
    background-color: #d2042d;
    height: 50px;
    border: "none";
  }

  .hero-section-search-btn :hover {
    background-color: #d2042d !important;
  }

  .mobile-card {
    width: 90%;
    height: auto;
    max-height: 100%;
    margin-top: 25%;
  }

  .custom-card {
    min-height: 280px;
  }
}

@media (min-width: 321px) and (max-width: 375px) {
  .create-accont-btn-signup.ant-btn-primary {
    display: flex;
    font-weight: 600 !important;
    color: #fff;
    background-color: #d2042d;
    padding: 20px 20px;
    font-size: 12px !important;
    height: 40px !important;
    text-align: center !important;
    justify-content: center !important;
    width: 45% !important;
  }

  .request-for-demo.ant-btn-variant-outlined {
    margin-top: 0rem !important;
    font-size: 12px !important;
    height: 40px !important;
    transition: none !important;
    width: 45% !important;
    font-weight: 600 !important;
  }

  .location-title-name .ant-typography {
    font-size: var(--Font-Font-Size-h4, 16px) !important;
  }

  .image-container {
    padding-left: 0 !important;
  }

  .title {
    display: flex;
    font-size: 1.8rem !important;
    justify-content: center !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  .how-it-works-title {
    font-size: 22px !important;
    word-break: break-word;
    line-height: 1.3;
  }

  .subtitle-text {
    font-size: 19px !important;
  }

  .visit-help-center-btn {
    height: 45px !important;
  }

  .visit-help-center-text {
    font-size: var(--Font-Font-Size-h6, 16px) !important;
  }

  .custom-card.ant-card .ant-card-body {
    padding: 0px !important;
  }
}

@media (min-width: 0px) and (max-width: 320px) {
  .title {
    display: flex;
    font-size: 1.5rem !important;
    justify-content: center !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  .campaign-description {
    font-family: Roboto;
    font-weight: 400;
    line-height: 2;
    font-size: 14px !important;
  }

  .subtitle-text {
    font-size: 16px !important;
    line-height: 23.5px !important;
  }

  .custom-card.ant-card .ant-card-body {
    padding: 0px !important;
  }

  .footer-link {
    font-size: 18px !important;
  }

  .footer-link-text {
    font-size: 18px !important;
  }

  .how-it-works-title.ant-typography {
    margin-bottom: 0px !important;
    font-family: "Roboto";
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h1, 20px) !important;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    padding-top: 10px !important;
  }

  .marketplace-card .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100% !important;
    height: 280px !important;
    width: 100% !important;
  }

  .marketplace-card.ant-card .ant-card-body {
    padding: 32px !important;
  }

  .benefits-signup-text.ant-typography {
    height: 10px !important;
    font-size: 18px !important;
  }

  .card-list-item strong {
    font-size: 18px !important;
  }

  .marketplace-card-list-text {
    font-size: 18px !important;
  }

  .card-header strong {
    font-size: 18px;
    color: #0a0f0d;
    font-weight: 900;
    word-wrap: break-word;
    margin-bottom: 0px !important;
  }

  .create-accont-btn-signup.ant-btn-primary {
    display: flex;
    font-weight: 600 !important;
    color: #fff;
    background-color: #d2042d;
    padding: 20px 20px;
    font-size: 11px !important;
    height: 40px !important;
    text-align: center !important;
    justify-content: center !important;
    width: 48% !important;
  }

  .request-for-demo.ant-btn-variant-outlined {
    margin-top: 0rem !important;
    font-size: 11px !important;
    height: 40px !important;
    transition: none !important;
    width: 48% !important;
    font-weight: 600 !important;
  }

  .default-btn {
    height: 45px !important;
  }

  .action-btn {
    font-family: Roboto;
    height: 45px !important;
  }

  .card-actions button {
    width: 100% !important;
    font-size: 16px;
    font-weight: 600;
  }

  .location-title-name.ant-typography {
    font-size: var(--Font-Font-Size-h4, 16px) !important;
  }

  .subtitle-text.ant-typography {
    margin-top: 5px !important;
    font-weight: 500 !important;
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h5, 20px);
    font-style: normal;
    font-weight: 500;
    line-height: 34.5px;
    margin-bottom: 1rem !important;
  }

  .faq-collapse .ant-collapse-item {
    border: none !important;
    border-radius: 10px;
    margin-bottom: 0rem !important;
  }

  .faq-collapse .ant-collapse-header {
    font-size: var(--Font-Font-Size-h5, 16px) !important;
  }

  .faq-answer-test.ant-typography {
    font-size: 15px !important;
  }

  .advertisement-link-faq {
    font-size: 16px !important;
    text-decoration: underline !important;
  }
}

.enquiry-chat-description {
  display: flex;
  align-items: center !important;
}

.enquiry-billboard-chat-div.ant-float-btn {
  bottom: 115px !important;
}

.enquiry-billboard-chat-div-mobile {
  height: 70px;
  width: 70px;
  background-color: #fff;
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  margin-right: 2%;
}

.enquiry-billboard-layout-mobile {
  display: flex;
  margin-top: -10%;
  z-index: 100;
  width: 100%;
  justify-content: end;
  position: fixed;
  top: 51rem;
  align-self: flex-start;
}

.segment-card-back-home {
  display: flex;
  padding: 0.625rem 1.0625rem;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
  flex-shrink: 0;
}

.segment-card-back-home.ant-card .ant-card-body {
  padding: 0px !important;
  border-radius: 0 0 8px 8px;
}

.segment-buyer-seller-component.ant-segmented .ant-segmented-item-selected {
  background-color: #eaeaea;
  color: rgba(0, 0, 0, 0.88);
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 1rem);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.ant-segmented.ant-segmented-lg .ant-segmented-item-label {
  display: flex !important;
  min-height: 45px !important;
  line-height: 36px;
  font-size: 19px;
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 1rem);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  justify-content: center !important;
}

.home-page-segement-card {
  background-color: transparent;
  border-radius: 10px;
}

.home-page-segement-card .ant-segmented-group {
  gap: 10px;
  background: #fff;
}

.home-page-segment-roles.ant-segmented {
  padding: 0.1px !important;
}

.home-page-segement-card.ant-card .ant-card-body {
  padding: 12px !important;
  background: #fff;
}

.home-page-segement-card .ant-segmented .ant-segmented-item {
  background: #fff;
}

.home-page-segement-card .ant-segmented .ant-segmented-item-selected {
  background: #f5f5f5;
}

.list-card {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.custom-card.ant-card .ant-card-body {
  padding: 15px !important;
}

.custom-service-card .ant-card-body {
  margin-top: 4rem;
  position: relative;
}

.read-more {
  margin-top: 20px;
}

.theme-red.ant-typography {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: 3.78rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 4rem;
}

.segment-buyer-seller-component .ant-segmented-item-label {
  padding: 8px 20px !important;
  align-items: center;
  width: auto;
  font-size: 16px;
}

.buyers-reach-description-text {
  color: #000;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h6, 1.1875rem) !important;
  font-style: normal;
  font-weight: 400;
  line-height: 1.78125rem;
}

.join-marketplace-title.ant-typography {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h1, 48px);
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  padding-top: 75px;
  font-family: "Roboto";
}

.benefits-signup-text.ant-typography {
  display: block;
  position: relative;
  height: 28px;
  margin: 0 0 0 0;
  color: #0a0f0d;
  font-family: "Roboto";
  font-size: 23px;
  font-weight: 800;
  line-height: 28px;
  text-align: left;
  white-space: nowrap;
  margin-bottom: 10px;
}

@media (min-width: 1025px) and (max-width: 1440px) {
  .desktop-view .ant-typography {
    color: #ffffff;
    margin-top: 1rem;
    font-size: var(--Font-Font-Size-h5, 20px) !important;
    font-style: normal;
    font-weight: 700;
    line-height: 30.6px;
    font-family: Roboto;
  }

  .segment-buyer-seller-component .ant-segmented-item-label {
    padding: 8px 20px !important;
    align-items: center;
    width: auto;
    font-size: 16px !important;
  }

  .create-accont-btn-signup.ant-btn-primary {
    margin-top: 3.5em;
    font-weight: 500;
    color: #fff;
    background-color: #d2042d;
    padding: 20px 20px;
    font-size: 16px;
    height: 60px !important;
  }

  .action-btn {
    background-color: #d2042d;
    color: white;
    border: none;
    font-weight: 600;
    width: 108px;
    height: 50px;
    margin-right: 20px;
    font-size: 1rem;
    border-radius: 0.3125rem;
  }

  .default-btn {
    border-radius: 0.3125rem;
    background: var(--Colors-Text-400, #3b3f3d);
    color: white;
    border: none;
    font-weight: 600;
    width: 108px;
    height: 50px;
    margin-right: 20px;
    font-size: 1rem;
  }

  .location-title-name.ant-typography {
    font-size: var(--Font-Font-Size-h4, 24px);
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .home-cont-title {
    color: #fff !important;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-family: "Roboto";
    font-size: 40px !important;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    text-align: center;
  }

  .request-for-demo.ant-btn-variant-outlined:hover {
    margin-top: 1.5rem !important;
    height: 50px !important;
  }
}

.enquiry-billboard-chat-div {
  height: 70px;
  width: 70px;
  background-color: #d2042d;
  display: flex;
  margin-right: -25px;
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
  overflow: hidden;
  transition: width 0.3s ease;
}

.enquiry-billboard-chat-div.ant-float-btn .ant-float-btn-body {
  width: 100%;
  height: 100%;
  display: flex;
  transition: all 0.2s;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: row;
}

.enquiry-billboard-chat-div.ant-float-btn-circle {
  border-top-left-radius: 40px !important;
  border-bottom-left-radius: 40px !important;
  border-bottom-right-radius: 0px !important;
  border-top-right-radius: 0px !important;
}

.enquiry-billboard-chat-div.ant-float-btn
  .ant-float-btn-body
  .ant-float-btn-content
  .ant-float-btn-icon {
  text-align: center;
  margin: auto;
  width: 25px !important;
  font-size: 18px;
  line-height: 1;
}

.enquiry-billboard-chat-div.ant-float-btn
  .ant-float-btn-body
  .ant-float-btn-content {
  overflow: visible !important;
}

.enquiry-icon {
  flex-shrink: 0;
}

.enquiry-text {
  opacity: 0;
  visibility: hidden;
  white-space: nowrap;
  margin-left: 10px;
  color: white;
  font-weight: 600;
  font-size: 19px;
  transition: opacity 0.3s ease 0.1s;
}

.float-chat-enquiry-btn-home.ant-float-btn-circle {
  width: 50px !important;
  height: 50px !important;
}

.float-chat-enquiry-btn-common {
  bottom: 90px !important;
  right: 15px !important;
  width: 50px !important;
  height: 50px !important;
}

.float-chat-enquiry-btn-home.ant-float-btn
  .ant-float-btn-body
  .ant-float-btn-content
  .ant-float-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px !important;
  height: 30px !important;
}

.float-chat-enquiry-btn-common.ant-float-btn
  .ant-float-btn-body
  .ant-float-btn-content
  .ant-float-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px !important;
  height: 30px !important;
}

.home-calendar .ant-picker .ant-picker-input > input {
  font-size: 14px !important;
  font-family: Roboto !important;
  color: #757575 !important;
  font-weight: 400 !important;
  line-height: 33.6px !important;
  text-align: center !important;
}

@media (min-width: 426px) and (max-width: 768px) {
  .location-item img {
    width: 100% !important;
    height: 100% !important;
    border-radius: 8px;
  }
}

@media (min-width: 768px) {
  .enquiry-billboard-chat-div:hover {
    width: 240px;
  }

  .enquiry-billboard-chat-div:hover .enquiry-text {
    opacity: 1;
    visibility: visible;
  }

  .float-chat-enquiry-btn-home.ant-float-btn-circle {
    width: 60px !important;
    height: 60px !important;
  }

  .float-chat-enquiry-btn-home.ant-float-btn-circle {
    bottom: 100px !important;
    right: 44px !important;
  }

  .float-chat-enquiry-btn-common.ant-float-btn-circle {
    width: 60px !important;
    height: 60px !important;
  }
}

@media (max-width: 768px) {
  .enquiry-billboard-chat-div {
    width: 240px;
  }

  .enquiry-text {
    opacity: 1;
    visibility: visible;
  }
}

.space-component {
  border-radius: 10px;
  border-width: 1px;
  background: #ffffff;
  border: 1px solid var(--Colors-Text-100, #b3b5b4);
  box-shadow: 2px 2px 30px 0px #0000000d;
  width: 80% !important;
}

.home_input_search .ant-input-outlined {
  border-style: none !important;
}

/* ========================================================
   MAP + WE GET YOU EVERYWHERE
   ======================================================== */
.home-aligned-wrapper {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 30px;
}

.home-aligned-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 80px;
  row-gap: 30px;
  align-items: center;
}

.section-bottom-space {
  padding-top: 70px;
  padding-bottom: 90px;
}

.home-grid-left,
.home-grid-right,
.locations-map-content {
  width: 100%;
  display: flex;
  gap: 24px;
  flex-direction: column;
}

/* <Text> in JSX, so display:block is required */
.aligned-main-title {
  display: block;
  color: #0a0a0a;
  font-family: Roboto, sans-serif;
  font-weight: 700;
  font-size: 48px;
  line-height: 1.15;
  margin: 0 0 18px 0;
  letter-spacing: -0.5px;
}

.aligned-main-title span {
  color: #d2042d;
}

.aligned-description-text {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.65;
  color: #4b5563;
  margin-bottom: 28px;
}

/* .usa-map-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
} */

.map-cities-badge {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 14px 0 18px 0;
}

.cities-count {
  font-family: "Roboto", sans-serif;
  font-size: 32px;
  font-weight: 900;
  color: #0a0a0a;
}

.cities-label {
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #4b5563;
}

.usa-statistics {
  display: flex;
  gap: 16px;
  width: 100%;
  /* same width as the map */
}

.usa-stat-card {
  border-radius: 12px !important;
  background: #ffffff !important;
  border: 1px solid #f0f2f5 !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03) !important;
  width: auto;
  flex: 1 1;
}

.usa-stat-card .ant-card-body {
  padding: 14px 18px !important;
}

.stat-card-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.usa-stat-number {
  display: block;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.1;
  color: #d2042d;
}

.usa-stat-label {
  display: block;
  margin-top: 4px;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
}

.stat-card-icon {
  font-size: 26px;
  color: #d1d5db;
}

.locations-reach-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  /* was 62% */
}

.reach-subtext {
  margin-bottom: 28px;
}

.reach-items-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.reach-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.reach-number {
  min-width: 30px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #d2042d;
  color: #ffffff;
  border-radius: 4px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 700;
  margin-top: 2px;
  flex-shrink: 0;
}

.reach-item-info {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.reach-item-title {
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}

.reach-item-description {
  margin-top: 3px;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
  line-height: 1.45;
}

.amp-reach-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4%;
  width: 75%;
  margin: 0 auto;
  padding: 40px 0 100px;
  box-sizing: border-box;
}

.amp-reach-section .amp-reach-left {
  flex: 0 0 48%;
  width: 48%;
  min-width: 0;
}

.amp-reach-section .amp-reach-right {
  flex: 0 0 48%;
  width: 48%;
  min-width: 0;
}

.amp-reach-section .amp-reach-right .aligned-main-title {
  font-size: clamp(30px, 2.5vw, 48px);
}

.amp-reach-section .amp-reach-right .aligned-description-text {
  font-size: clamp(13px, 0.83vw, 16px);
}

.amp-reach-section .reach-item-title {
  font-size: clamp(14px, 0.94vw, 18px);
}

.amp-reach-section .reach-item-description {
  font-size: clamp(12px, 0.75vw, 14px);
}

@media (max-width: 1024px) {
  .amp-reach-section {
    width: 84%;
    margin: 0 auto;
    padding: 30px 0 60px;
    gap: 4%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .amp-reach-section .amp-reach-right {
    flex: 0 0 48%;
    width: 48%;
    min-width: 0;
  }

  .amp-reach-section .amp-reach-left {
    flex: 0 0 48%;
    width: 48%;
    min-width: 0;
  }

  .home-aligned-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .amp-reach-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    margin: 0 auto 50px;
    gap: 32px;
    padding: 40px 0;
  }

  .amp-reach-section .amp-reach-left,
  .amp-reach-section .amp-reach-right {
    flex: none;
    width: 100%;
    padding-left: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .amp-reach-section .amp-reach-right .aligned-main-title {
    font-size: 32px !important;
    line-height: 1.2;
  }

  .amp-reach-section .amp-reach-right .aligned-description-text,
  .reach-subtext {
    font-size: 16px !important;
    line-height: 1.5;
  }

  .usa-statistics {
    display: flex;
    flex-direction: row;
    gap: 14px;
    width: 100%;
  }

  .usa-stat-card {
    width: 50%;
    flex: 1 1;
  }

  .usa-stat-number {
    font-size: 19px !important;
  }

  .usa-stat-label {
    font-size: 13px !important;
  }

  .reach-items-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .reach-item {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    width: 100%;
  }

  .reach-number {
    font-size: 13px !important;
  }

  .reach-item-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .amp-reach-section .reach-item-title {
    font-size: 19px !important;
    font-weight: 600;
  }

  .amp-reach-section .reach-item-description {
    font-size: 16px !important;
    line-height: 1.4;
  }
}

@media (max-width: 480px) {
  .home-aligned-wrapper {
    padding: 0 16px;
  }

  .aligned-main-title {
    font-size: 28px;
  }

  .usa-statistics {
    flex-direction: column;
    gap: 10px;
  }
}

/* ========================================================
   FORMAT TICKER (INFINITE SCROLLING MARQUEE)
   ======================================================== */
.format-ticker-section {
  width: 100%;
  height: 109px;
  background-color: #d2042d;
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
  box-shadow: 0 4px 20px rgba(210, 4, 45, 0.15);
}

.format-ticker-track {
  display: flex;
  width: max-content;
  align-items: center;
  animation: ticker-scroll 25s linear infinite;
  white-space: nowrap;
}

.format-ticker-track:hover {
  animation-play-state: paused;
}

.format-ticker-item {
  display: inline-flex;
  align-items: center;
  padding: 0 42px;
}

.format-ticker-item span {
  font-family: "Roboto", "Arial Black", sans-serif;
  font-size: 34px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #ffffff;
  text-transform: uppercase;
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
}

@keyframes ticker-scroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

@media (max-width: 1024px) {
  .format-ticker-section {
    height: 90px;
  }

  .format-ticker-item span {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .format-ticker-section {
    width: 100%;
    height: 75px;
    display: flex;
    align-items: center;
  }

  .format-ticker-item {
    padding: 0 24px;
    display: inline-flex;
    align-items: center;
  }

  .format-ticker-item span {
    font-size: 19px !important;
  }
}

@media (max-width: 480px) {
  .format-ticker-section {
    height: 60px;
  }

  .format-ticker-item {
    padding: 0 16px;
  }

  .format-ticker-item span {
    font-size: 18px;
  }
}

/* ========================================================
   MEDIA SHOWCASE (SEE AMP IN ACTION)
   ======================================================== */
.media-showcase-section {
  width: 100%;
  background: #ffffff;
  padding-top: 88px;
  padding-bottom: 45px;
}

.media-showcase-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.media-showcase-header {
  width: 100%;
  margin: 0 0 14px 0;
  /* margin-left: 28%; */
  /* display: flex; */
  /* align-content: center; */
  /* flex-direction: column; */
}

/* Two <Text> children: 1st = title, 2nd = subtitle */
.media-showcase-header > .ant-typography {
  display: block;
  font-family: Roboto, sans-serif;
}

.media-showcase-header > .ant-typography:first-child {
  margin: 0;
  font-size: 48px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.8px;
  color: #080808;
}

.media-showcase-header > .ant-typography:first-child span {
  color: #d2042d;
}

.media-showcase-header > .ant-typography:last-child {
  margin: 8px 0 0 0;
  font-size: 16px;
  line-height: 1.4;
  color: #4b5563;
}

.media-showcase-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 85%;
  row-gap: 8%;
  column-gap: 4%;
  /* margin-left: 12%; */
  flex-wrap: wrap;
}

.media-showcase-left {
  width: 44%;
  min-width: 0;
}

.media-showcase-right {
  width: 40%;
}

.media-main-image-container {
  position: relative;
  width: 100%;
  height: 380px;
  overflow: hidden;
  border-radius: 15px;
  background: #eeeeee;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.media-main-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transition: transform 0.25s ease;
}

.media-main-image-container:hover .media-main-image {
  transform: scale(1.01);
}

.media-duration {
  position: absolute;
  top: 13px;
  right: 13px;
  height: 22px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  border-radius: 12px;
  background: rgba(31, 48, 67, 0.92);
  color: #ffffff;
  font-family: "Roboto", sans-serif;
  font-size: 10px;
  font-weight: 500;
  z-index: 5;
}

.media-main-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 55px 18px 19px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75));
  z-index: 3;
}

/* Two <Text> children: 1st = title, 2nd = description */
.media-main-overlay > .ant-typography {
  display: block;
  font-family: Roboto, sans-serif;
}

.media-main-overlay > .ant-typography:first-child {
  margin: 0 0 6px 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
  color: #ffffff;
}

.media-main-overlay > .ant-typography:last-child {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.88);
}

.media-bottom-controls {
  width: 100%;
  height: 30px;
  margin-top: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.media-dots {
  display: flex;
  align-items: center;
  gap: 6px;
}

.media-dot {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #d4d8dd;
  cursor: pointer;
  transition: all 0.2s ease;
}

.media-dot.active {
  width: 20px;
  border-radius: 5px;
  background: #d2042d;
}

.media-list-title {
  height: 20px;
  margin: 0 0 9px 0;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #3f4348;
}

.media-image-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.media-image-card {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 9px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 9px;
  cursor: pointer;
  transition:
    border-color 0.2s,
    box-shadow 0.2s,
    transform 0.2s;
}

.media-image-card:hover {
  border-color: #d2042d;
  transform: translateX(1px);
}

.media-image-card.active {
  border: 2px solid #d2042d;
  padding: 6px 8px;
  box-shadow: 0 2px 8px rgba(210, 4, 45, 0.05);
}

.media-thumbnail {
  width: 62px;
  height: 46px;
  flex-shrink: 0;
  display: block;
  object-fit: cover;
  border-radius: 6px;
}

.media-card-content {
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

/* Red category label (plain <span>) */
.media-card-content span {
  display: block;
  margin: 0 0 2px 0;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: #d2042d;
}

/* Title is a <Text>; this overrides the span rule above */
.media-card-content .ant-typography {
  display: block;
  margin: 0;
  overflow: hidden;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  color: #20252b;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (max-width: 1024px) {
  .media-showcase-section {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 40px;
  }

  .media-showcase-container {
    width: 96%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    gap: 20px;
  }
  .media-showcase-content {
    width: 100%;
    grid-template-columns: 1fr;
    row-gap: 24px;
  }

  .media-main-image-container {
    height: 360px;
  }
}

@media (max-width: 768px) {
  .media-showcase-section {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 40px;
  }

  .media-showcase-container {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    gap: 20px;
  }

  .media-showcase-header {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 14px;
  }

  .media-showcase-header > .ant-typography:first-child {
    font-size: 32px !important;
    line-height: 1.2;
  }

  .media-showcase-header > .ant-typography:last-child {
    font-size: 16px !important;
  }

  .media-showcase-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .media-showcase-left {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .media-main-image-container {
    width: 100%;
    height: 320px;
  }

  .media-duration {
    font-size: 13px !important;
  }

  .media-main-overlay > .ant-typography:first-child {
    font-size: 19px !important;
  }

  .media-main-overlay > .ant-typography:last-child {
    font-size: 16px !important;
  }

  .media-showcase-right {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .media-list-title {
    font-size: 19px !important;
    font-weight: 600;
  }

  .media-image-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .media-image-card {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    height: 72px;
    padding: 8px 12px;
  }

  .media-thumbnail {
    width: 68px;
    height: 50px;
    flex-shrink: 0;
  }

  .media-card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    width: 100%;
  }

  .media-card-content span {
    font-size: 13px !important;
  }

  .media-card-content .ant-typography {
    font-size: 19px !important;
  }
}

@media (max-width: 480px) {
  .media-showcase-header > .ant-typography:first-child {
    font-size: 28px;
  }

  .media-showcase-header > .ant-typography:last-child {
    font-size: 13px;
  }

  .media-main-image-container {
    height: 240px;
  }

  .media-image-card {
    height: 68px;
  }

  .media-thumbnail {
    width: 60px;
    height: 48px;
  }
}

/* ========================================================
   LET'S GET STARTED (BUYER / SELLER)
   ======================================================== */
.get-started-section {
  width: 100%;
  display: flex;
  background: #ffffff;
  padding: 62px 0 70px;
  justify-content: center;
}

.get-started-container {
  width: 75%;
  display: flex;
  flex-direction: column;
  align-content: space-around !important;
  flex-wrap: wrap;
}

.get-started-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 36px;
}

/* Two <Text> children: 1st = title, 2nd = subtitle */
.get-started-heading > .ant-typography {
  display: block;
  font-family: Roboto, sans-serif;
}

.get-started-heading > .ant-typography:first-child {
  margin: 0;
  font-size: 48px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -1px;
  color: #080808;
}

.get-started-heading > .ant-typography:first-child span {
  color: #d2042d;
}

.get-started-heading > .ant-typography:last-child {
  margin: 9px 0 0;
  font-size: 16px;
  line-height: 1.4;
  color: #4b5563;
}

.user-type-toggle {
  width: 245px;
  height: 45px;
  display: flex;
  align-items: center;
  padding: 3px;
  background: #ffffff;
  border: 1px solid #dedede;
  border-radius: 9px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
}

.user-type-button {
  flex: 1 1;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #68707a;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.user-type-button.active {
  background: #d2042d;
  color: #ffffff;
  box-shadow: 0 2px 5px rgba(210, 4, 45, 0.18);
}

.user-type-icon {
  font-size: 12px;
  line-height: 1;
}

.get-started-card {
  width: 100%;
  height: 472px;
  display: flex;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e7e7e7;
  border-radius: 18px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}

.get-started-image {
  position: relative;
  width: 100%;
  height: 471px;
  overflow: hidden;
  background: #eeeeee;
}

.get-started-image img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.get-started-content {
  width: 100%;
  height: 442px;
  padding: 36px;
  display: flex;
  flex-direction: column;
}

.get-started-content-icon {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
  border-radius: 9px;
  background: #fff0f3;
  color: #d2042d;
  font-size: 23px;
  font-weight: 700;
}

/* Card title ("I'm a Seller / Buyer") is a <Text> */
.get-started-content > .ant-typography {
  display: block;
  margin: 0 0 24px;
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  color: #171717;
}

.get-started-description {
  max-width: 500px;
  margin: 0 0 25px;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.9;
  color: #606060;
}

.get-started-points {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 28px;
}

.get-started-point {
  display: flex;
  align-items: center;
  gap: 11px;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  color: #374151;
}

.get-started-check {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #d2042d;
  font-size: 20px;
}

.get-started-action-button {
  width: 100%;
  height: 43px;
  margin-top: auto;
  border: none;
  border-radius: 5px;
  background: #d2042d;
  color: #ffffff;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.get-started-action-button:hover {
  background: #b50326;
}

.get-started-arrow {
  margin-left: 6px;
  font-size: 17px;
}

@media (max-width: 1024px) {
  .get-started-section {
    width: 100%;
    display: flex;
    background: #ffffff;
    padding: 62px 0 70px;
    justify-content: center;
  }
  .get-started-container {
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .get-started-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;
  }

  .get-started-card {
    height: auto;
    grid-template-columns: 1fr;
  }

  .get-started-image {
    height: 350px;
  }

  .get-started-content {
    height: auto;
    min-height: 400px;
  }
}

@media (max-width: 768px) {
  .get-started-section {
    width: 100%;
    padding: 50px 0;
    display: flex;
    justify-content: center;
  }

  .get-started-container {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .get-started-header {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .get-started-heading > .ant-typography:first-child {
    font-size: 32px !important;
    line-height: 1.2;
  }

  .get-started-heading > .ant-typography:last-child {
    font-size: 16px !important;
  }

  .user-type-toggle {
    width: 100%;
    display: flex;
    gap: 8px;
  }

  .user-type-button {
    font-size: 16px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .get-started-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    border-radius: 14px;
    overflow: hidden;
  }

  .get-started-image {
    width: 100%;
    height: 280px;
  }

  .get-started-content {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;
  }

  .get-started-content > .ant-typography {
    font-size: 19px !important;
    margin: 0 0 10px 0;
  }

  .get-started-description {
    font-size: 16px !important;
    line-height: 1.6;
    margin: 0 0 14px 0;
  }

  .get-started-points {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin-bottom: 20px;
  }

  .get-started-point {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px !important;
  }

  .get-started-action-button,
  .get-started-content .rtgs-btn {
    width: 100%;
    height: 48px;
    font-size: 16px !important;
  }

  .get-started-arrow {
    font-size: 16px !important;
  }
}

@media (max-width: 480px) {
  .get-started-section {
    padding: 40px 0;
  }

  .get-started-heading > .ant-typography:first-child {
    font-size: 28px;
  }

  .get-started-image {
    height: 240px;
  }

  .get-started-content {
    padding: 24px 18px;
  }
}

/* ========================================================
   WHAT OUR CLIENTS SAY (TESTIMONIALS)
   (h2 and p are still real tags in the JSX, so unchanged)
   ======================================================== */
.testimonials-section {
  width: 100%;
  background: #000000;
  padding: 80px 0 90px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
}

.testimonials-container {
  width: 75%;
}

.testimonials-title {
  margin: 0 0 56px;
  font-family: "Roboto", sans-serif;
  font-size: 48px;
  font-weight: 800;
  line-height: 1.15;
  color: #ffffff;
  text-transform: uppercase;
}

.testimonials-title span {
  color: #d2042d;
}

.testimonials-grid {
  display: flex;
  gap: 40px;
}

.testimonial-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  min-height: 240px;
  padding: 32px;
  background: #1f1f1f;
  border-radius: 10px;
}

.testimonial-quote {
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.55;
  color: #ffffff;
}

.testimonial-author {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 20px;
  border-top: 1px solid #3a3a3a;
}

.testimonial-name {
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
}

.testimonial-role {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #9ca3af;
}

@media (max-width: 1024px) {
  .testimonials-section {
    width: 100%;
    padding: 50px 0 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .testimonials-container {
    width: 80%;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .testimonials-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .testimonial-card {
    min-height: auto;
  }
}

@media (max-width: 768px) {
  .testimonials-section {
    width: 100%;
    padding: 50px 0 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .testimonials-container {
    width: 90%;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .testimonials-title {
    font-size: 32px;
    margin-bottom: 24px;
    line-height: 1.2;
  }

  .testimonials-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .testimonial-card {
    width: 100%;
    min-height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
    padding: 20px;
    border-radius: 10px;
  }

  .testimonial-quote {
    font-size: 16px !important;
    line-height: 1.6;
  }

  .testimonial-author {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 14px;
    width: 100%;
  }

  .testimonial-name {
    font-size: 19px !important;
    font-weight: 600;
  }

  .testimonial-role {
    font-size: 13px !important;
  }
}

@media (max-width: 576px) {
  .testimonials-section {
    padding: 50px 0 60px;
  }

  .testimonials-title {
    font-size: 29px;
    margin-bottom: 36px;
  }
}

/* ========================================================
   FREQUENTLY ASKED QUESTIONS (FAQ)
   ======================================================== */
.home-faq-section {
  width: 100%;
  background: #ffffff;
  padding: 80px 0 90px;
}

.home-faq-container {
  width: 75%;
  max-width: calc(100% - 40px);
  margin: 0 auto;
}

.home-faq-title {
  margin: 0 0 40px;
  font-family: "Roboto", sans-serif;
  font-size: 48px;
  font-weight: 800;
  line-height: 1.15;
  color: #080808;
  text-transform: uppercase;
}

.home-faq-title span {
  color: #d2042d;
}

.home-faq-list {
  width: 100%;
}

.home-faq-item {
  border-bottom: 1px solid #ececec;
}

.home-faq-question {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 28px 40px 28px 0;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;
  color: #0a0a0a;
}

.home-faq-icon {
  position: relative;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.home-faq-icon::before,
.home-faq-icon::after {
  content: "";
  position: absolute;
  background: #0a0a0a;
  transition: transform 0.25s ease;
}

.home-faq-icon::before {
  top: 50%;
  left: 0;
  width: 100%;
  height: 1.5px;
  transform: translateY(-50%);
}

.home-faq-icon::after {
  top: 0;
  left: 50%;
  width: 1.5px;
  height: 100%;
  transform: translateX(-50%);
}

.home-faq-item.open .home-faq-icon::after {
  transform: translateX(-50%) scaleY(0);
}

.home-faq-answer-wrap {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease;
}

.home-faq-item.open .home-faq-answer-wrap {
  grid-template-rows: 1fr;
}

.home-faq-answer-inner {
  overflow: hidden;
}

.home-faq-answer {
  margin: 0;
  padding: 0 40px 28px 0;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.75;
  color: #5b6270;
}

.home-faq-more {
  display: flex;
  justify-content: center;
  margin-top: 56px;
}

.home-faq-more-button {
  width: 170px;
  height: 50px;
  border: none;
  border-radius: 8px;
  background: #d2042d;
  color: #ffffff;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}

.home-faq-more-button:hover {
  background: #b50326;
}
@media (max-width: 1024px) {
  .home-faq-section {
    width: 100%;
    padding: 50px 0 60px;
  }

  .home-faq-container {
    width: 80%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .home-faq-section {
    width: 100%;
    padding: 50px 0 60px;
  }

  .home-faq-container {
    width: 90%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0 auto;
  }

  .home-faq-title {
    font-size: 32px;
    margin-bottom: 20px;
    line-height: 1.2;
  }

  .home-faq-list {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .home-faq-item {
    width: 100%;
  }

  .home-faq-question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    padding: 18px 0;
    font-size: 19px !important;
    line-height: 1.35;
  }

  .home-faq-answer,
  .faq-answer-test,
  .home-faq-answer-inner .ant-typography {
    padding-right: 0;
    font-size: 16px !important;
    line-height: 1.6;
  }

  .home-faq-more {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    width: 100%;
  }

  .home-faq-more-button {
    font-size: 16px !important;
    height: 48px;
    width: 170px;
  }
}

/* ========================================================
   READY TO GET STARTED (RTGS)
   ======================================================== */
.rtgs {
  width: 100%;
  background-color: #050505;
  padding: 95px 20px 105px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.rtgs-inner {
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
}

.rtgs-text {
  color: #ffffff;
  font-size: 48px;
  font-family: "Roboto", sans-serif;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin: 0 0 16px 0;
  line-height: 1.15;
  text-align: center;
}

.rtgs-para {
  color: #e5e7eb;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.5;
  max-width: 740px;
  margin: 0 auto;
  text-align: center;
}

.rtgs-btn-comp {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 22px;
  flex-wrap: wrap;
}

.rtgs-btn {
  min-width: 185px;
  height: 45px;
  padding: 0 26px;
  border: none;
  border-radius: 8px;
  background: #d2042d !important;
  color: #ffffff;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s ease,
    transform 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rtgs-btn:hover {
  background: #b50326;
  transform: translateY(-1px);
}

.rtgs-features,
.rtgs-last {
  margin-top: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  flex-wrap: wrap;
}

.rtgs-feature-item {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #e5e7eb;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
}

.rtgs-check-icon {
  font-size: 16px;
  color: #ffffff;
}

@media (max-width: 768px) {
  .rtgs {
    width: 100%;
    padding: 60px 20px 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .rtgs-inner {
    width: 90%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    text-align: center;
  }

  .rtgs-text {
    font-size: 32px;
    line-height: 1.2;
  }

  .rtgs-para {
    font-size: 16px !important;
    line-height: 1.5;
  }

  .rtgs-btn-comp {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 14px;
    align-items: center;
    margin-top: 28px;
  }

  .rtgs-btn {
    width: 100%;
    max-width: 280px;
    height: 48px;
    font-size: 16px !important;
  }

  .rtgs-features,
  .rtgs-last {
    display: flex;
    flex-direction: column;
    gap: 14px;
    align-items: center;
    width: 100%;
    margin-top: 24px;
  }

  .rtgs-feature-item {
    font-size: 13px !important;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
}

/* ========================================================
   SEARCH BILLBOARD ADVERTISING ACROSS THE COUNTRY
   ======================================================== */
.country-search-section {
  width: 100%;
  background: #ffffff;
  padding: 65px 0 75px;
}

.country-search-container {
  width: 75%;
  max-width: calc(100% - 40px);
  margin: 0 auto;
  text-align: left;
}

/* <Text> in JSX, so display:block is required */
.country-search-title {
  display: block;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: var(--Font-Font-Size-h6, 20px);
  line-height: 20px;
  letter-spacing: 0px;
  color: #0a0a0a;
  margin: 0 0 8px 0;
}

.country-search-subtitle {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #757575;
  margin: 0 0 34px 0;
}

.country-search-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.country-search-column {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.country-search-link {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: #d2042d !important;
  text-decoration: underline !important;
  transition:
    opacity 0.2s ease,
    color 0.2s ease;
  cursor: pointer;
  display: inline-block;
  width: fit-content;
}

.country-search-link:hover {
  color: #b50326 !important;
  opacity: 0.85;
}

@media (max-width: 1024px) {
  .country-search-section {
    width: 100%;
    background: #ffffff;
    padding: 65px 0 75px;
  }

  .country-search-container {
    width: 80%;
    max-width: calc(100% - 40px);
    margin: 0 auto;
    text-align: left;
  }

  .country-search-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .country-search-section {
    width: 100%;
    padding: 45px 0 50px;
  }

  .country-search-container {
    width: 90%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 0 auto;
  }

  .country-search-title {
    font-size: 19px !important;
    line-height: 1.3;
    margin-bottom: 6px;
  }

  .country-search-subtitle {
    font-size: 16px !important;
    line-height: 1.5;
    margin-bottom: 20px;
  }

  .country-search-grid {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }

  .country-search-column {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .country-search-link {
    font-size: 16px !important;
  }
}

@media (max-width: 576px) {
  .country-search-section {
    padding: 45px 0 50px;
  }

  .country-search-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
.image-above-footer {
  width: 100%;
}
.footer-image {
  width: 100%;
  height: max-content;
  margin-bottom: -4px;
}
/* @media screen and (max-width: 768px) {
  .image-above-footer {
    width: 100%;
    margin-bottom: 0;
    overflow: hidden;
    line-height: 0;
  }

  .footer-image {
    width: 100%;
    height: auto;
    display: block;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/features/HomePage/Homepage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kDAAkD;EAClD,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB;;cAEY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,+EAA+E;EAC/E,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;;EAEzB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,UAAU;EACV,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BC;AACH;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;;EAEhB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;6DAE6D;;AAE7D,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB;;wBAEsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,mDAAmD;AACnD;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;IAC5B,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;6DAE6D;;AAE7D,gCAAgC;AAChC;EACE,sBAAsB;EACtB,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE;IACE,eAAe;EACjB;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;6DAE6D;;AAE7D,gCAAgC;AAChC;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,OAAO;EACP,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;AACd;;AAEA,0EAA0E;AAC1E;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,UAAU;EACV,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE;IACE,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,OAAO;IACP,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,aAAa;IACb,UAAU;IACV,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;;IAEE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,qEAAqE;AACrE;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;;6DAE6D;AAC7D,6BAA6B;AAC7B;EACE,gBAAgB;EAChB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,4CAA4C;IAC5C,qBAAqB;IACrB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,4CAA4C;IAC5C,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,kCAAkC;IAClC,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,kCAAkC;IAClC,4BAA4B;IAC5B,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;;IAEvB,kBAAkB;EACpB;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,4BAA4B;IAC5B,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,kCAAkC;IAClC,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,4BAA4B;IAC5B,kCAAkC;IAClC,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;IACb,4BAA4B;IAC5B,kCAAkC;IAClC,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,sCAAsC;IACtC,oDAAoD;IACpD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,kCAAkC;IAClC,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yDAAyD;EACzD,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,oDAAoD;IACpD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,2CAA2C;IAC3C,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,4CAA4C;IAC5C,qBAAqB;IACrB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;EACzB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;;;;EAIE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;EACjD,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;6DAE6D;AAC7D;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,oCAAoC;EACpC,qDAAqD;EACrD,WAAW;EACX,SAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,OAAO;EACP,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,YAAY;EACd;;EAEA;IACE,aAAa;IACb,UAAU;IACV,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;;IAEE,UAAU;IACV,WAAW;IACX,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,UAAU;IACV,SAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;;6DAE6D;AAC7D;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;6DAE6D;AAC7D;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qDAAqD;AACrD;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,6EAA6E;EAC7E,UAAU;AACZ;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf;;;kBAGgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,SAAS;EACX;EACA;IACE,WAAW;IACX,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;6DAE6D;AAC7D;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;;6DAG6D;AAC7D;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;;6DAE6D;AAC7D;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,MAAM;EACN,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;;;IAGE,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;;6DAE6D;AAC7D;EACE,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;wBAEsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;;6DAE6D;AAC7D;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC;;mBAEiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;GAaG","sourcesContent":[".bg-container {\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: 81vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #f5f5f5;\n  position: relative;\n  box-shadow: 0px -2px 15px 0px rgba(0, 0, 0, 0.14);\n}\n\n.bg-container .highlight {\n  color: #d2042d;\n  font-weight: bold;\n}\n\n.section-partition {\n  color: #fff;\n  text-align: center;\n  font-size: 23px;\n  font-weight: 600;\n  font-family: Roboto;\n}\n\n.home-calendar {\n  background-color: #fff;\n  height: 80px;\n  display: inline-flex;\n  align-items: center;\n  padding-right: 0rem;\n}\n\n.home-text {\n  color: #5b5e5d;\n  font-weight: 600;\n}\n\n.dma-select-btn {\n  min-width: 22vw;\n  width: auto !important;\n  text-align: left !important;\n}\n\n.bg-description {\n  font-family: Roboto;\n  font-size: 1.2rem;\n  color: #000;\n  /* text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */\n  /* text-align: center; */\n  font-weight: 500;\n  margin-top: 10px;\n  max-width: 80% !important;\n}\n\n.dropdown-btn.ant-select-single .ant-select-selector {\n  font-size: 19px;\n  color: #757575;\n  cursor: pointer !important;\n}\n\n.search-btn\n  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n  background-color: #d2042d !important;\n  border-color: none;\n}\n\n.ant-picker-range .ant-picker-active-bar {\n  bottom: -1px;\n  height: 2px;\n  background: #d2042d;\n  opacity: 0;\n  transition: all 0.3s ease-out;\n  pointer-events: none;\n}\n\n.ant-btn:not(:disabled):focus-visible {\n  outline: 3px solid #d2042d;\n  outline-offset: 1px;\n  transition:\n    outline-offset 0s,\n    outline 0s;\n}\n\n.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {\n  border: none !important;\n  background: #ffffff;\n}\n\n.ant-select-multiple .ant-select-selection-placeholder {\n  position: absolute;\n  top: 50%;\n  inset-inline-start: 11px;\n  inset-inline-end: 11px;\n  transform: translateY(-50%);\n  transition: all 0.3s;\n  font-size: 14px;\n  color: #757575 !important;\n}\n\n.ant-select-dropdown .ant-select-item-option-content {\n  font-family: Roboto;\n  font-size: 14px !important;\n}\n\n.ant-select-selection-item-remove {\n  display: none !important;\n}\n\n.ant-select-multiple\n  .ant-select-selection-overflow\n  .ant-select-selection-item-content {\n  font-size: 19px !important;\n}\n\n.ant-select-outlined.ant-select-multiple .ant-select-selection-item {\n  background-color: unset !important;\n  color: #757575 !important;\n  border: none !important;\n}\n\n.ant-select-dropdown\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n  background-color: unset !important;\n}\n\n.dropdown-btn.ant-select-single.ant-select-show-arrow\n  .ant-select-selection-item {\n  font-size: 14px !important;\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n}\n\n.dropdown-btn.ant-select-single.ant-select-show-arrow\n  .ant-select-selection-placeholder {\n  font-family: Roboto;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.ant-picker-range-separator {\n  display: none !important;\n}\n\n.ant-select-multiple .ant-select-selection-wrap {\n  align-self: center;\n}\n\n.dropdown-btn {\n  width: 9.8vw;\n  height: 80px;\n  color: #757575;\n  font-weight: 600;\n  font-size: 19px;\n  margin-left: -3px;\n}\n\n.search-btn {\n  font-family: Roboto;\n  background-color: #d2042d;\n  color: #fff;\n  border: 1px #d2042d solid;\n  height: 80px;\n  font-size: 20px;\n  width: 11.81vw;\n}\n\n.search-btn:active {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  border: none !important;\n}\n\n.search-btn:hover {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  border: 1px #d2042d solid !important;\n}\n\n.home-cont {\n  /* background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0)); */\n  border-radius: 12px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent !important;\n}\n\n.home-cont-title {\n  color: #fff !important;\n  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  font-family: \"Roboto\";\n  font-size: 32px !important;\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n  text-align: center;\n}\n\n.home-updated-title-color {\n  color: #000 !important;\n}\n\n.dropdown-btn:hover {\n  color: #757575 !important;\n  border-color: #ccc !important;\n}\n\n.dropdown-btn:active {\n  color: #757575 !important;\n\n  border-color: #ccc !important;\n}\n\n.top-billboards {\n  color: #fff;\n  font-size: 1.05rem;\n  text-overflow: ellipsis;\n}\n\n.home_input_search {\n  width: 22.86vw;\n  height: 80px;\n  padding-left: 2vw;\n  width: 100% !important;\n}\n\n.home_input_search .ant-input-prefix {\n  margin-right: 1rem;\n}\n\n.home_input_search .ant-input {\n  color: #757575 !important;\n  font-family: Roboto;\n  font-size: 18px !important;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.home_input_search:hover {\n  border: 1px solid #ccc !important;\n  border: none !important;\n}\n\n.home_input_search::placeholder {\n  font-size: 19px;\n  color: #757575;\n}\n\n.home-calendar::placeholder {\n  color: #757575;\n}\n\n.faq-collapse .ant-collapse-content > .ant-collapse-content-box {\n  padding: 16px 30px;\n}\n\n.ant-input-group.ant-input-group-compact > *:first-child {\n  border-start-start-radius: 20px !important;\n  border-end-start-radius: 20px !important;\n  cursor: pointer;\n  font-family: Roboto !important;\n}\n\n.ant-input-group.ant-input-group-compact > *:last-child {\n  border-start-end-radius: 20px !important;\n  border-end-end-radius: 20px !important;\n}\n\n.input-group {\n  margin-top: 6px;\n  width: 90%;\n  height: 100px;\n  justify-content: flex-start;\n  align-items: center;\n  display: flex;\n}\n\n.special-style-class {\n  width: 100% !important;\n}\n\n.ant-layout-header {\n  padding: 0 50px;\n}\n\n.booking-text {\n  background: #fff;\n  height: 46px;\n  width: 288px;\n  color: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.09);\n  margin-top: 18px;\n  border-radius: 5px;\n  gap: 8px;\n}\n\nfooter {\n  background-color: #ff4d4f;\n}\n\nfooter .ant-row {\n  justify-content: center;\n}\n\n.hero-section-search-btn:hover {\n  background-color: #d2042d !important;\n}\n\n/* Mobile specific styling */\n@media (max-width: 567px) {\n  .ant-layout-header {\n    padding: 0 20px;\n  }\n\n  .mobile-card {\n    width: 90%;\n    height: 69%;\n    margin-top: 8%;\n  }\n\n  .hero-section-search-btn {\n    color: #fff;\n    background-color: #d2042d;\n    height: 60px;\n    border: \"none\";\n  }\n\n  .hero-section-search-btn :hover {\n    background-color: #d2042d !important;\n    color: #fff !important;\n    box-shadow: none !important;\n    border: none !important;\n    cursor: pointer;\n  }\n\n  .create-accont-btn-signup.ant-btn-primary:hover {\n    background-color: #d2042d !important;\n    color: #fff !important;\n    box-shadow: none !important;\n    border: none !important;\n    cursor: pointer;\n  }\n\n  .ant-input-group {\n    flex-direction: column;\n  }\n\n  footer .ant-row {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  footer .ant-tag {\n    font-size: 14px;\n    margin: 5px;\n  }\n}\n\n.red-bg {\n  background-color: #d2042d;\n  padding: 20px 0px;\n}\n\n.home-container {\n  padding: 0 16px;\n  max-width: 100%;\n}\n\n.desktop-view {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-evenly;\n  overflow: hidden;\n}\n\n.desktop-item-title {\n  cursor: pointer;\n}\n\n.carousel-mobile .carousel-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.carousel-content h5 {\n  color: #ffffff;\n}\n\n.carousel-item-title {\n  font-size: 18px;\n  margin-left: 0.8rem;\n}\n\n.title {\n  font-size: 2.95rem !important;\n  color: white;\n}\n\n.desktop-view img {\n  margin-right: 8px;\n}\n\n.desktop-view .ant-typography {\n  color: #ffffff;\n  margin-top: 1rem;\n  font-size: var(--Font-Font-Size-h5, 23px) !important;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 33.6px;\n  font-family: Roboto;\n}\n\n.ant-container {\n  max-width: 1550px;\n  margin: 0 auto;\n  padding: 0 15px;\n}\n\n.responsive-gap {\n  padding: 2rem 0;\n}\n\n.responsive-text-container {\n  text-align: center;\n  padding: 16px;\n}\n\n.how-it-works-title.ant-typography {\n  margin-bottom: 0px !important;\n  font-family: \"Roboto\";\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h1, 48px);\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n  padding-top: 0px;\n}\n\n.how-it-works-title span {\n  color: #d2042d;\n}\n\n.subtitle-text.ant-typography {\n  font-family: Roboto;\n  margin-top: 1px !important;\n  font-weight: 500 !important;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h5, 23px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 34.5px;\n}\n\n.theme-red span {\n  border-bottom: 4px solid #d2042d;\n}\n\n.signup-text strong {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h5, 1.4375rem);\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n}\n\n.cardtext-para2 {\n  color: #000;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h6, 1.1875rem);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.78125rem;\n  margin-top: 10px;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.custom-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  min-height: 260px;\n  width: 100%;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  background-color: #fff;\n  text-align: left;\n}\n\n.service-card-wrapper {\n  position: relative;\n}\n\n.custom-service-card {\n  clip-path: polygon(\n    0 0,\n    100% 0,\n    100% 100%,\n    0 100%,\n\n    /* Start of curve at bottom of vertical cut */ 0 90px,\n\n    /* Start higher for curve space */ /* Bottom curve points (simulated) */ 5px\n      85px,\n    10px 82px,\n    15px 81px,\n    20px 80px,\n\n    /* Horizontal line */ 75px 80px,\n\n    /* Shorter to account for curve */ /* Top curve points */ 78px 75px,\n    79px 70px,\n    80px 65px,\n    80px 60px,\n\n    /* Vertical line up */ 80px 5px,\n\n    /* Back to start with slight curve */ 75px 2px,\n    70px 1px,\n    65px 0,\n    0 0\n  );\n}\n\n.service-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 80px;\n  height: 80px;\n}\n\n.scrollable-container {\n  display: flex;\n}\n\n.scrollable-container .ant-col {\n  display: flex;\n  justify-content: stretch;\n}\n\n.scrollable-container::-webkit-scrollbar {\n  display: none;\n}\n\n.buyer-seller-card {\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  margin: 0 auto;\n}\n\n.card-icon-container {\n  margin-bottom: 16px;\n}\n\n.circle-border {\n  background-color: #d7a7b099;\n  display: inline-block;\n  border: 2px solid #e0e0e0;\n  border-radius: 50%;\n  padding: 15px;\n}\n\n.card-icon {\n  width: 50px;\n  height: 50px;\n}\n\n.card-title {\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #8e9190;\n  word-wrap: break-word;\n  margin-bottom: 10px;\n}\n\n.card-header strong {\n  font-size: 18px;\n  color: #0a0f0d;\n  font-weight: 900;\n  word-wrap: break-word;\n  margin-bottom: 8px;\n}\n\n.card-list {\n  margin-top: 1rem;\n  flex-grow: 1;\n  padding-left: 1em;\n  height: auto;\n}\n\n.marketplace-card-list-text {\n  position: relative;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 19px;\n  font-weight: 400;\n  text-align: left;\n}\n\n.card-list-item {\n  padding: 5px 0 !important;\n  font-size: 19px;\n  line-height: 1.5;\n  color: black;\n  list-style: disc;\n  font-weight: 400 !important;\n  font-family: \"Roboto\" !important;\n}\n\n.card-list-item strong {\n  position: relative;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 19px;\n  font-weight: 700;\n  text-align: left;\n}\n\n.footer-title {\n  font-family: Roboto;\n  margin-top: 16px;\n  color: #0a0f0d;\n  font-weight: bold;\n}\n\n.footer-link {\n  margin-top: 16px;\n  color: #d2042d;\n  font-size: 19px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 600;\n  text-decoration: underline;\n  line-height: 25.6px;\n  display: block;\n}\n\n.footer-link-text {\n  color: #d2042d;\n  font-size: 19px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 600;\n  text-decoration: underline;\n  line-height: 25.6px;\n  display: block;\n}\n\n/* Marketplace.css */\n.marketplace-card {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background: white;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05) !important;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.marketplace-card img {\n  width: 90% !important;\n}\n\n.marketplace-card .image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 45%;\n}\n\n.video-card-alignment {\n  padding-bottom: 30px !important;\n  padding-top: 30px !important;\n}\n\n.jack-video-calendar {\n  font-size: 19px;\n  font-weight: 400;\n  font-family: Roboto;\n  color: #d2042d;\n}\n\n.video-caption-text {\n  gap: 30px;\n}\n\n.marketplace-card .video-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.marketplace-card img {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.marketplace-card .signup-text {\n  font-weight: bold;\n}\n\n.marketplace-card .benefits-list {\n  padding-left: 1em;\n  margin-top: 1.5rem;\n}\n\n.marketplace-card .benefits-list li {\n  margin-bottom: 10px;\n}\n\n.marketplace-card .create-account-btn {\n  color: white;\n  font-size: 19px;\n  font-weight: 400;\n  word-wrap: break-word;\n  background-color: #d2042d;\n  border: none;\n  text-align: center;\n  border-radius: 4px;\n  margin-top: 20px;\n\n  padding: 20px 10px;\n}\n\n.create-account-btn:hover {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  border: none !important;\n  cursor: pointer;\n}\n\n/* Locations.css */\n\n.location-item .ant-card-body {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.location-item img {\n  width: 307px;\n  height: 336px;\n  border-radius: 8px;\n}\n\n.locations {\n  overflow: hidden;\n}\n\n.location-title {\n  text-align: center;\n  margin-top: 10px;\n}\n\n.location {\n  cursor: pointer;\n}\n\n.location-title-name.ant-typography {\n  color: #000;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h4, 23px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.location-title-name.ant-typography:hover {\n  color: #d2042d;\n}\n\n.home-page-buttons-section {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: flex-start;\n  gap: 15px !important;\n  align-items: center;\n}\n\n.create-accont-btn-signup.ant-btn-primary {\n  margin-top: 3.5em;\n  font-weight: 500;\n  color: #fff;\n  background-color: #d2042d;\n  border-radius: 0.3125rem;\n  padding: 20px 20px;\n  font-size: 16px;\n  height: 60px !important;\n  width: 228px !important;\n  transition: none !important;\n}\n\n.request-for-demo.ant-btn-variant-outlined {\n  font-family: Roboto;\n  margin-top: 3.5rem !important;\n  font-weight: 500;\n  color: #000 !important;\n  background-color: #f0f0f0 !important;\n  padding: 20px 20px;\n  font-size: 16px;\n  height: 60px !important;\n  border-radius: #f0f0f0 !important;\n  border-color: #f0f0f0 !important;\n  width: 228px !important;\n}\n\n.request-for-demo.ant-btn-variant-outlined:hover {\n  color: #000 !important;\n  background-color: #f0f0f0 !important;\n  border-radius: #f0f0f0 !important;\n  border-color: #f0f0f0 !important;\n}\n\n.create-accont-btn-signup.ant-btn-primary:hover {\n  cursor: pointer;\n}\n\n.create-accont-btn-signup .ant-btn-primary:active {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  box-shadow: none !important;\n  border: none !important;\n  cursor: pointer;\n  border-radius: 0.3125rem;\n}\n\n.faq-collapse {\n  border: none;\n  background-color: #f5f5f5;\n}\n\n.faq-collapse-section {\n  margin-top: 35px;\n}\n\n.faq-collapse p {\n  padding-left: 2rem;\n}\n\n.faq-collapse .ant-collapse-header {\n  color: #000;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h5, 1.4375rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 2.15625rem;\n}\n\n.faq-collapse .ant-collapse-content {\n  font-size: 19px;\n  border: none;\n  border-radius: 10px;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: 1.1875rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.78125rem;\n}\n\n.faq-collapse .ant-collapse-item {\n  border: none !important;\n  border-radius: 10px;\n  margin-bottom: 2rem;\n}\n\n.ant-collapse-expand-icon {\n  display: inline !important;\n}\n\n.faq-collapse .ant-collapse-item-active .ant-collapse-header {\n  background-color: white !important;\n  border-radius: 10px 10px 0px 0px !important;\n}\n\n.faq-collapse .ant-collapse-item-active {\n  background-color: white !important;\n  box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.05);\n}\n\n.visit-help-center-btn {\n  cursor: pointer;\n  display: inline-flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d);\n  height: 60px !important;\n}\n\n.visit-help-center-btn.ant-btn-primary:hover {\n  background: var(--Colors-Primary-500, #d2042d);\n}\n\n.visit-help-center-text {\n  color: #fff;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: 25.6px;\n}\n\n.marketplace-card .image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 45% !important;\n  height: 480px !important;\n}\n\n.advertisement-link-faq {\n  color: var(--Colors-Text-500, #0a0f0d) !important;\n  font-family: Roboto;\n  font-size: 19px !important;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28.5px;\n  text-decoration: underline !important;\n}\n\n.advertisement-link-faq:hover {\n  color: #d2042d !important;\n  text-decoration: underline !important;\n}\n\n.faq-answer-test.ant-typography {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: 1.1875rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.78125rem;\n}\n\n.marketplace-card-row {\n  display: flex;\n  width: 100%;\n  gap: 5%;\n}\n\n.image-container-img {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.content-container-css {\n  padding: 15px 50px 0px 0px;\n  width: 50%;\n}\n\n.top-cities-row-home {\n  display: flex;\n  margin-right: -30px !important;\n  flex-wrap: nowrap;\n}\n\n.marketplace-card.ant-card .ant-card-body {\n  padding: 40px !important;\n}\n\n.tooltip-seller-restriction {\n  font-family: Roboto;\n  font-size: 14px !important;\n}\n\n/* ========================================================\n   1. VIDEO HERO SECTION\n   ======================================================== */\n\n/* --- Base Desktop Styles --- */\n.video-hero-container {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.video-hero-container video {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.video-hero-content {\n  position: absolute;\n  top: 50%;\n  left: 12%;\n  width: 60%;\n  transform: translateY(-50%);\n  z-index: 10;\n  color: #fff;\n}\n\n.video-hero-badge {\n  display: inline-block;\n  padding: 7px 14px;\n  margin-bottom: 20px;\n  border-radius: 100px;\n  background: #adaaaa80;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  padding-left: 12px;\n  gap: 4px;\n}\n\n.video-hero-dot {\n  color: #d2042d;\n}\n\n.video-hero-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  color: #ffffff;\n}\n\n/* Hero heading (now a <Text>, so it must be display:block) */\n.home_main_heading {\n  display: block;\n  margin: 0 0 15px;\n  font-family: Roboto;\n  font-weight: 800;\n  font-style: ExtraBold;\n  font-size: 48px;\n  line-height: 1.15;\n  letter-spacing: -0.5px;\n  color: #fff;\n  text-transform: uppercase;\n}\n\n.home_main_heading span {\n  color: #ed0b3b;\n}\n\n.home_main_paragraph,\n.video-hero-content p {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 20px;\n  line-height: 1.5;\n  color: #e5e7eb;\n  margin-bottom: 20px;\n}\n\n.video-hero-select-text {\n  font-family: Roboto, sans-serif;\n  font-size: 16px;\n  color: #ffffff;\n  margin-bottom: 16px;\n  font-weight: 400;\n}\n\n.video-hero-buttons {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.video-hero-btn-primary {\n  border: none;\n  background: #d2042d;\n  color: #fff;\n  padding: 14px 30px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  text-align: center;\n  transition:\n    background 0.2s ease,\n    transform 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-hero-btn-primary:hover {\n  background: #b50326;\n  transform: translateY(-1px);\n}\n\n.video-hero-btn-outline {\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(4px);\n  color: #fff;\n  padding: 13px 26px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n  font-size: 15px;\n  text-align: center;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-hero-btn-outline:hover {\n  border-color: #ffffff;\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-1px);\n}\n\n/* --- Video Hero: Tablet (max-width: 1024px) --- */\n@media (max-width: 1024px) {\n  .video-hero-content {\n    left: 8% !important;\n    width: 75% !important;\n  }\n\n  .home_main_heading {\n    font-size: 34px !important;\n  }\n\n  .home_main_paragraph,\n  .video-hero-content p {\n    font-size: 16px !important;\n  }\n}\n\n/* --- Video Hero: Mobile / Tablet (max-width: 768px) --- */\n@media (max-width: 768px) {\n  .video-hero-container {\n    min-height: 560px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .video-hero-container video {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .video-hero-content {\n    position: relative !important;\n    top: unset !important;\n    left: unset !important;\n    transform: none !important;\n    width: 90% !important;\n    max-width: 600px !important;\n    margin: 0 auto !important;\n    padding: 40px 0 !important;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .video-hero-badge {\n    margin-bottom: 14px !important;\n    padding: 5px 12px !important;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .video-hero-text {\n    font-size: 13px !important;\n  }\n\n  .home_main_heading {\n    font-size: 32px !important;\n    line-height: 1.25 !important;\n    margin-bottom: 14px !important;\n  }\n\n  .home_main_paragraph,\n  .video-hero-content p {\n    font-size: 16px !important;\n    line-height: 1.55 !important;\n    margin-bottom: 16px !important;\n  }\n\n  .video-hero-select-text {\n    font-size: 16px !important;\n    margin-bottom: 12px !important;\n  }\n\n  .video-hero-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .video-hero-btn-primary,\n  .video-hero-btn-outline {\n    width: 100%;\n    height: 48px;\n    padding: 12px 16px !important;\n    font-size: 16px !important;\n  }\n}\n\n/* --- Video Hero: Small Mobile Phones (max-width: 480px) --- */\n@media (max-width: 480px) {\n  .video-hero-container {\n    min-height: 600px;\n  }\n\n  .home_main_heading {\n    font-size: 24px !important;\n    line-height: 1.2 !important;\n  }\n\n  .video-hero-buttons {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .video-hero-btn-primary,\n  .video-hero-btn-outline {\n    width: 100%;\n    height: 48px;\n  }\n}\n\n/* ========================================================\n   2. RED STAT BANNER\n   ======================================================== */\n\n/* --- Base Desktop Styles --- */\n.Add-banner-alert {\n  width: 100% !important;\n  background-color: var(--Colors-Primary-500, #d2042d);\n  border-radius: 0%;\n}\n\n.banner-content {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 35px;\n  margin-bottom: 34px;\n  flex-wrap: wrap;\n}\n\n.banner-content-span {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 18px;\n  color: #ffffff;\n}\n\n/* --- Red Stat Banner: Tablet (max-width: 1024px) --- */\n@media (max-width: 1024px) {\n  .banner-content-span {\n    font-size: 18px;\n  }\n}\n\n/* --- Red Stat Banner: Tablet & Mobile (max-width: 768px) --- */\n@media (max-width: 768px) {\n  .banner-content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    width: 90%;\n    margin: 20px auto;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  .banner-content-span {\n    font-size: 16px !important;\n  }\n}\n\n/* --- Red Stat Banner: Small Mobile (max-width: 480px) --- */\n@media (max-width: 480px) {\n  .banner-content-span {\n    font-size: 13px;\n  }\n}\n\n/* ========================================================\n   3. WHAT IS ADVERTISING MARKETPLACE\n   ======================================================== */\n\n/* --- Base Desktop Styles --- */\n.advertising-marketplace-section {\n  padding: 70px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n}\n\n.advertising-content-main {\n  width: 75%;\n  margin: 60px auto 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4%;\n  flex-direction: row;\n  box-sizing: border-box;\n}\n\n.advertising-content-new {\n  flex: 0 0 48%;\n  width: 48%;\n  min-width: 0;\n}\n\n/* Both <Text> items are direct children: 1st = heading, 2nd = paragraph */\n.advertising-content-new > .ant-typography {\n  display: block;\n  font-family: Roboto;\n}\n\n.advertising-content-new > .ant-typography:first-child {\n  margin-bottom: 16px;\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 1.15;\n  color: #0a0a0a;\n}\n\n.advertising-content-new > .ant-typography:first-child span {\n  color: #d2042d;\n}\n\n.advertising-content-new > .ant-typography:nth-child(2) {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #444;\n}\n\n.marketplace-features {\n  display: flex;\n  gap: 12px;\n  margin-top: 28px;\n}\n\n.feature-card {\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 105px;\n  padding: 14px;\n  border: 1px solid #f3f4f6;\n  border-radius: 14px;\n  box-sizing: border-box;\n  background-color: #f9fafb;\n}\n\n.feature-icon {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n  border-radius: 8px;\n  background: #fff0f3;\n  color: #d50032;\n  font-size: 18px;\n}\n\n/* Title is a <Text> inside .feature-card */\n.feature-card .ant-typography {\n  display: block;\n  margin: 0 0 8px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #222;\n}\n\n.feature-card span {\n  display: block;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #777;\n}\n\n.advertising-main-img,\n.advertising-content-main > img {\n  flex: 0 0 48%;\n  width: 48%;\n  max-width: 48%;\n  height: auto;\n  object-fit: cover;\n  border-radius: 20px;\n  display: block;\n}\n\n.advertising-image {\n  width: 43%;\n}\n\n.advertising-image img {\n  display: block;\n  width: 100%;\n  height: 310px;\n  object-fit: cover;\n  border-radius: 22px;\n}\n\n/* --- Advertising Marketplace: Tablet (max-width: 1024px) --- */\n@media (max-width: 1024px) {\n  .advertising-content-main {\n    width: 84%;\n    margin: 40px auto 30px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 4%;\n    box-sizing: border-box;\n  }\n\n  .advertising-content-new {\n    flex: 0 0 48%;\n    width: 48%;\n    min-width: 0;\n  }\n\n  .advertising-main-img,\n  .advertising-content-main > img {\n    flex: 0 0 48%;\n    width: 48%;\n    max-width: 48%;\n    height: auto;\n    object-fit: cover;\n    border-radius: 20px;\n    display: block;\n  }\n\n  .advertising-content-new > .ant-typography:first-child {\n    font-size: 38px;\n  }\n}\n\n/* --- Advertising Marketplace: Mobile & Tablet (max-width: 768px) --- */\n@media (max-width: 768px) {\n  .advertising-content-main {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 28px;\n    margin: 36px auto;\n  }\n\n  .advertising-content-new {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .advertising-content-new > .ant-typography:first-child {\n    font-size: 32px !important;\n    line-height: 1.2 !important;\n    margin-bottom: 6px;\n  }\n\n  .advertising-content-new > .ant-typography:nth-child(2),\n  .advertising-content-new > .ant-typography {\n    font-size: 16px !important;\n    line-height: 1.6;\n  }\n\n  .advertising-main-img,\n  .advertising-content-main > img {\n    width: 100%;\n    max-width: 500px;\n    height: auto;\n    object-fit: cover;\n    border-radius: 16px;\n    display: block;\n  }\n\n  .marketplace-features {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    margin-top: 16px;\n  }\n\n  .feature-card {\n    width: 100% !important;\n    padding: 14px 16px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .feature-card .ant-typography {\n    font-size: 19px !important;\n    font-weight: 600;\n    margin: 0 0 4px 0;\n  }\n\n  .feature-card span {\n    font-size: 13px !important;\n  }\n}\n\n/* --- Advertising Marketplace: Small Mobile (max-width: 480px) --- */\n@media (max-width: 480px) {\n  .advertising-content-new > .ant-typography:first-child {\n    font-size: 26px !important;\n  }\n\n  .advertising-main-img,\n  .advertising-content-main > img {\n    width: 100% !important;\n    max-height: 220px;\n    border-radius: 14px;\n  }\n}\n\n/* ========================================================\n   EXISTING RESPONSIVE / MEDIA QUERIES\n   ======================================================== */\n/* Responsive Media Queries */\n@media (max-width: 1024px) {\n  /* Tablet View */\n  .desktop-view > h5 {\n    font-size: 14px;\n  }\n\n  .popular-search {\n    margin-top: 1vh;\n    width: 100%;\n    margin-left: -3vh !important;\n    padding-left: 20px;\n  }\n\n  .dma-filter-cont {\n    margin-left: 1% !important;\n  }\n\n  .ant-select-multiple .ant-select-selection-placeholder {\n    position: absolute;\n    top: 50%;\n    inset-inline-start: 11px;\n    inset-inline-end: 11px;\n    transform: translateY(-50%);\n    transition: all 0.3s;\n    font-size: 16px;\n    color: #757575 !important;\n  }\n\n  .ant-select-dropdown .ant-select-item-option-content {\n    font-size: 16px !important;\n  }\n\n  .ant-select-selection-item-remove {\n    display: none !important;\n  }\n\n  .desktop-view .ant-typography {\n    font-size: 16px !important;\n  }\n\n  .ant-select-outlined.ant-select-multiple .ant-select-selection-item {\n    background-color: unset !important;\n    color: #757575 !important;\n    border: none !important;\n  }\n\n  .ant-select-dropdown\n    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background-color: unset !important;\n  }\n\n  .ant-select-single.ant-select-show-arrow .ant-select-selection-item {\n    font-size: 16px;\n    color: #757575;\n  }\n\n  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {\n    font-size: 15px !important;\n    color: #757575 !important;\n  }\n\n  .dropdown-btn {\n    font-family: Roboto;\n    width: 16vw;\n    height: 90px;\n    color: #757575;\n    font-weight: 600;\n    font-size: 16px;\n    margin-left: -3px;\n  }\n\n  .search-btn {\n    font-family: Roboto;\n    background-color: #d2042d;\n    color: #fff;\n    border: 1px #d2042d solid;\n    height: 90px !important;\n    font-size: 17px;\n    width: 13.81vw;\n  }\n\n  .home-calendar {\n    background-color: #fff;\n    height: 90px;\n    display: inline-flex;\n    align-items: center;\n    padding-right: 1rem;\n    width: 200px;\n  }\n\n  .home_input_search {\n    height: 90px;\n    padding-left: 2vw;\n  }\n\n  .home_input_search::placeholder {\n    font-size: 16px;\n    color: #757575;\n  }\n\n  .home-cont-title {\n    /* color: #fff !important; */\n    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    font-family: \"Roboto\";\n    font-size: 40px !important;\n    font-style: normal;\n    font-weight: 900;\n    line-height: normal;\n    text-align: center;\n  }\n\n  .bg-description {\n    font-size: 18px;\n    /* color: #fff; */\n    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    text-align: center;\n  }\n\n  .how-it-works-title.ant-typography {\n    margin-bottom: 0px !important;\n    font-family: \"Roboto\";\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h1, 40px);\n    font-style: normal;\n    font-weight: 900;\n    line-height: normal;\n    padding-top: 0px;\n  }\n\n  .subtitle-text.ant-typography {\n    margin-top: 1px !important;\n    font-weight: 500 !important;\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h5, 20px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 34.5px;\n  }\n\n  .theme-red.ant-typography {\n    font-size: 3rem !important;\n  }\n\n  .signup-text strong {\n    font-size: var(--Font-Font-Size-h5, 1.2375rem) !important;\n  }\n\n  .cardtext-para2 {\n    font-size: var(--Font-Font-Size-h6, 19px);\n  }\n\n  .benefits-signup-text.ant-typography {\n    height: 18px !important;\n    font-size: 22px !important;\n  }\n\n  .marketplace-card-list-text {\n    font-size: 18px !important;\n  }\n\n  .marketplace-card .image-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    max-width: 45% !important;\n    height: 480px !important;\n  }\n\n  .marketplace-card .video-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 480px !important;\n  }\n\n  .marketplace-card img {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .price strong {\n    font-size: var(--Font-Font-Size-h2, 2.2rem) !important;\n  }\n\n  .location-title-name.ant-typography {\n    font-size: var(--Font-Font-Size-h4, 22px) !important;\n  }\n\n  .faq-collapse .ant-collapse-header {\n    font-size: var(--Font-Font-Size-h5, 1.2375rem) !important;\n  }\n\n  .faq-answer-test.ant-typography {\n    font-size: 18px !important;\n  }\n\n  .benefits-signup-text.ant-typography {\n    height: 16px !important;\n    font-size: 22px !important;\n  }\n\n  .card-list-item strong {\n    font-size: 19px !important;\n  }\n\n  .location-item img {\n    width: 225px !important;\n    height: 320px !important;\n    border-radius: 8px;\n  }\n}\n\n/* Mobile specific styling */\n@media (max-width: 768px) {\n  .desktop-view .ant-typography {\n    font-size: 15px !important;\n  }\n\n  .video-card-alignment {\n    padding-bottom: 0px !important;\n    padding-top: 0px !important;\n  }\n\n  .mobile-card {\n    width: 90%;\n    height: auto;\n    max-height: 85%;\n    margin-top: 0%;\n    text-align: center;\n  }\n\n  .hero-secrion-input-group {\n    display: flex;\n    gap: 6px;\n    margin-top: 1rem;\n  }\n\n  .hero-section-search-btn {\n    color: #fff;\n    background-color: #d2042d;\n    height: 50px;\n    border: \"none\";\n  }\n\n  .hero-section-search-btn :hover {\n    background-color: #d2042d !important;\n  }\n\n  .ant-layout-header {\n    padding: 0 20px;\n  }\n\n  .campaign-description {\n    font-family: Roboto;\n    font-weight: 400;\n    line-height: 2;\n    font-size: 16px !important;\n  }\n\n  .ant-input-group {\n    flex-direction: column;\n  }\n\n  footer .ant-row {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  footer .ant-tag {\n    font-size: 14px;\n    margin: 5px;\n  }\n\n  .cardtext-para2 {\n    font-size: 18px !important;\n  }\n\n  .title {\n    font-size: 2rem !important;\n  }\n\n  .location-item img {\n    width: 165px !important;\n    height: 250px !important;\n    border-radius: 8px;\n  }\n\n  .location-title-name.ant-typography {\n    font-size: var(--Font-Font-Size-h4, 18px) !important;\n  }\n\n  .top-cities-row-home {\n    /* width: 100% !important; */\n    margin-left: 0px !important;\n    flex-wrap: wrap !important;\n  }\n\n  .dma-select-btn {\n    min-width: 82% !important;\n    width: auto !important;\n    text-align: left !important;\n  }\n}\n\n.layout {\n  position: relative;\n}\n\n@media (min-width: 769px) {\n  .responsive-text {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .scrollable-container {\n    justify-content: center;\n  }\n\n  .desktop-view img {\n    margin-right: 8px;\n    width: 25px !important;\n  }\n\n  .theme-red.ant-typography {\n    font-size: 2.5rem !important;\n  }\n\n  .signup-text strong {\n    font-size: 18px !important;\n  }\n\n  .buyers-reach-description-text {\n    font-size: 17px !important;\n  }\n\n  .benefits-signup-text.ant-typography {\n    height: 16px !important;\n    font-size: 20px !important;\n  }\n\n  .marketplace-card img {\n    width: 100% !important;\n    height: 80% !important;\n  }\n\n  .create-accont-btn-signup.ant-btn-primary {\n    margin-top: 2rem !important;\n    background-color: #d2042d;\n    font-size: 16px !important;\n    height: 52px !important;\n    transition: none !important;\n  }\n\n  .request-for-demo.ant-btn-variant-outlined {\n    margin-top: 2rem !important;\n    font-size: 16px !important;\n    height: 52px !important;\n    transition: none !important;\n  }\n\n  .how-it-works-title.ant-typography {\n    margin-bottom: 0px !important;\n    font-size: var(--Font-Font-Size-h1, 32px) !important;\n  }\n\n  .visit-help-center-text {\n    font-size: var(--Font-Font-Size-h6, 18px) !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .desktop-view > h5 {\n    font-size: 12px;\n  }\n\n  .scrollable-card {\n    margin: 10px 0;\n  }\n\n  .custom-card {\n    min-height: 280px;\n  }\n\n  .scrollable-container {\n    display: flex;\n    overflow-x: auto;\n    justify-content: start;\n    max-width: 100%;\n  }\n\n  .responsive-gap {\n    padding: 1rem 0;\n  }\n\n  .faq-collapse .ant-collapse-header {\n    font-size: var(--Font-Font-Size-h5, 1.4rem) !important;\n  }\n\n  .faq-answer-test.ant-typography {\n    font-size: 1.2rem !important;\n  }\n\n  .custom-card.ant-card .ant-card-body {\n    padding: 0px !important;\n  }\n\n  .create-accont-btn-signup.ant-btn-primary {\n    margin-top: 3.5em;\n    font-weight: 500;\n    color: #fff;\n    background-color: #d2042d;\n    padding: 20px 20px;\n    font-size: 14px !important;\n    height: 50px !important;\n    width: 55% !important;\n    font-weight: 600 !important;\n  }\n\n  .request-for-demo.ant-btn-variant-outlined {\n    margin-top: 2rem !important;\n    font-size: 14px !important;\n    height: 52px !important;\n    transition: none !important;\n    width: 55%;\n    font-weight: 600 !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .how-it-works-title {\n    font-size: 24px !important;\n    word-break: break-word;\n    line-height: 1.3;\n  }\n\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panels {\n    display: unset;\n    flex-wrap: nowrap;\n  }\n\n  .home-page-calendar-component .ant-picker-dropdown-range {\n    inset: -500px auto auto -19px !important;\n  }\n\n  .subtitle-text {\n    font-size: 20px !important;\n  }\n\n  .card-header,\n  .card-title {\n    font-size: 16px;\n    line-height: 1.2;\n  }\n\n  .card-list-item {\n    font-size: 16px;\n  }\n\n  .card-list-item strong {\n    /* display: inline-block; */\n    margin-right: 4px;\n    font-size: 16px;\n  }\n\n  .marketplace-card img {\n    width: 100% !important;\n  }\n\n  .marketplace-card .create-account-btn {\n    width: 100%;\n    padding: 25px;\n  }\n\n  .ant-container {\n    margin: 0 !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .mobile-card {\n    width: 90%;\n    height: auto;\n    max-height: 81%;\n    margin-top: 11%;\n    padding-bottom: 5%;\n  }\n\n  .custom-card {\n    min-height: 280px;\n  }\n}\n\n@media (max-width: 425px) {\n  .mobile-card {\n    width: 90%;\n    height: auto;\n    max-height: 95%;\n    margin-top: 11%;\n  }\n\n  .custom-card {\n    min-height: 280px;\n  }\n\n  .marketplace-card .image-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    max-width: 100% !important;\n    height: 325px !important;\n    width: 100% !important;\n  }\n\n  .image-container {\n    padding-left: 15 !important;\n    padding-right: 0 !important;\n  }\n\n  .content-container {\n    padding: 20px 0px 0px 10px !important;\n  }\n\n  .title {\n    display: flex;\n    font-size: 2rem !important;\n    justify-content: center !important;\n    flex-direction: column !important;\n    align-items: center !important;\n  }\n\n  .create-accont-btn-signup.ant-btn-primary {\n    display: flex;\n    margin-top: 0rem !important;\n    font-weight: 500;\n    color: #fff;\n    background-color: #d2042d;\n    padding: 20px 20px;\n    font-size: 16px;\n    height: 45px !important;\n    text-align: center !important;\n    justify-content: center !important;\n    margin-left: 0rem !important;\n    width: 45% !important;\n    font-size: 14px !important;\n  }\n\n  .request-for-demo.ant-btn-variant-outlined {\n    margin-top: 0rem !important;\n    font-size: 14px !important;\n    height: 45px !important;\n    transition: none !important;\n    width: 45% !important;\n    font-weight: 600 !important;\n  }\n\n  .top-cities-row-home {\n    width: 100% !important;\n    margin-left: 0px !important;\n    flex-wrap: wrap !important;\n  }\n\n  .location-item {\n    width: 50% !important;\n  }\n\n  .location-item img {\n    width: 100% !important;\n    height: auto !important;\n\n    border-radius: 8px;\n  }\n\n  .faq-collapse .ant-collapse-header {\n    font-size: var(--Font-Font-Size-h5, 1rem) !important;\n  }\n\n  .faq-answer-test.ant-typography {\n    font-size: 16px !important;\n  }\n\n  .visit-help-center-btn {\n    height: 50px !important;\n  }\n\n  .visit-help-center-text {\n    font-size: var(--Font-Font-Size-h6, 16px) !important;\n  }\n\n  .custom-card.ant-card .ant-card-body {\n    padding: 0px !important;\n  }\n\n  .enquiry-billboard-chat-div-mobile {\n    height: 60px !important;\n    width: 60px !important;\n    background-color: #fff;\n    border-top-left-radius: 40px;\n    border-bottom-left-radius: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    border-radius: 50%;\n    margin-right: 2%;\n  }\n}\n\n@media (max-width: 400px) {\n  .mobile-card {\n    width: 90%;\n    height: auto;\n    max-height: 100%;\n    margin-top: 19%;\n  }\n\n  .custom-card {\n    min-height: 280px;\n  }\n}\n\n@media (max-width: 360px) {\n  .hero-section-search-btn {\n    color: #fff;\n    background-color: #d2042d;\n    height: 50px;\n    border: \"none\";\n  }\n\n  .hero-section-search-btn :hover {\n    background-color: #d2042d !important;\n  }\n\n  .mobile-card {\n    width: 90%;\n    height: auto;\n    max-height: 100%;\n    margin-top: 25%;\n  }\n\n  .custom-card {\n    min-height: 280px;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 375px) {\n  .create-accont-btn-signup.ant-btn-primary {\n    display: flex;\n    font-weight: 600 !important;\n    color: #fff;\n    background-color: #d2042d;\n    padding: 20px 20px;\n    font-size: 12px !important;\n    height: 40px !important;\n    text-align: center !important;\n    justify-content: center !important;\n    width: 45% !important;\n  }\n\n  .request-for-demo.ant-btn-variant-outlined {\n    margin-top: 0rem !important;\n    font-size: 12px !important;\n    height: 40px !important;\n    transition: none !important;\n    width: 45% !important;\n    font-weight: 600 !important;\n  }\n\n  .location-title-name .ant-typography {\n    font-size: var(--Font-Font-Size-h4, 16px) !important;\n  }\n\n  .image-container {\n    padding-left: 0 !important;\n  }\n\n  .title {\n    display: flex;\n    font-size: 1.8rem !important;\n    justify-content: center !important;\n    flex-direction: column !important;\n    align-items: center !important;\n  }\n\n  .how-it-works-title {\n    font-size: 22px !important;\n    word-break: break-word;\n    line-height: 1.3;\n  }\n\n  .subtitle-text {\n    font-size: 19px !important;\n  }\n\n  .visit-help-center-btn {\n    height: 45px !important;\n  }\n\n  .visit-help-center-text {\n    font-size: var(--Font-Font-Size-h6, 16px) !important;\n  }\n\n  .custom-card.ant-card .ant-card-body {\n    padding: 0px !important;\n  }\n}\n\n@media (min-width: 0px) and (max-width: 320px) {\n  .title {\n    display: flex;\n    font-size: 1.5rem !important;\n    justify-content: center !important;\n    flex-direction: column !important;\n    align-items: center !important;\n  }\n\n  .campaign-description {\n    font-family: Roboto;\n    font-weight: 400;\n    line-height: 2;\n    font-size: 14px !important;\n  }\n\n  .subtitle-text {\n    font-size: 16px !important;\n    line-height: 23.5px !important;\n  }\n\n  .custom-card.ant-card .ant-card-body {\n    padding: 0px !important;\n  }\n\n  .footer-link {\n    font-size: 18px !important;\n  }\n\n  .footer-link-text {\n    font-size: 18px !important;\n  }\n\n  .how-it-works-title.ant-typography {\n    margin-bottom: 0px !important;\n    font-family: \"Roboto\";\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h1, 20px) !important;\n    font-style: normal;\n    font-weight: 900;\n    line-height: normal;\n    padding-top: 10px !important;\n  }\n\n  .marketplace-card .image-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    max-width: 100% !important;\n    height: 280px !important;\n    width: 100% !important;\n  }\n\n  .marketplace-card.ant-card .ant-card-body {\n    padding: 32px !important;\n  }\n\n  .benefits-signup-text.ant-typography {\n    height: 10px !important;\n    font-size: 18px !important;\n  }\n\n  .card-list-item strong {\n    font-size: 18px !important;\n  }\n\n  .marketplace-card-list-text {\n    font-size: 18px !important;\n  }\n\n  .card-header strong {\n    font-size: 18px;\n    color: #0a0f0d;\n    font-weight: 900;\n    word-wrap: break-word;\n    margin-bottom: 0px !important;\n  }\n\n  .create-accont-btn-signup.ant-btn-primary {\n    display: flex;\n    font-weight: 600 !important;\n    color: #fff;\n    background-color: #d2042d;\n    padding: 20px 20px;\n    font-size: 11px !important;\n    height: 40px !important;\n    text-align: center !important;\n    justify-content: center !important;\n    width: 48% !important;\n  }\n\n  .request-for-demo.ant-btn-variant-outlined {\n    margin-top: 0rem !important;\n    font-size: 11px !important;\n    height: 40px !important;\n    transition: none !important;\n    width: 48% !important;\n    font-weight: 600 !important;\n  }\n\n  .default-btn {\n    height: 45px !important;\n  }\n\n  .action-btn {\n    font-family: Roboto;\n    height: 45px !important;\n  }\n\n  .card-actions button {\n    width: 100% !important;\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  .location-title-name.ant-typography {\n    font-size: var(--Font-Font-Size-h4, 16px) !important;\n  }\n\n  .subtitle-text.ant-typography {\n    margin-top: 5px !important;\n    font-weight: 500 !important;\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h5, 20px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 34.5px;\n    margin-bottom: 1rem !important;\n  }\n\n  .faq-collapse .ant-collapse-item {\n    border: none !important;\n    border-radius: 10px;\n    margin-bottom: 0rem !important;\n  }\n\n  .faq-collapse .ant-collapse-header {\n    font-size: var(--Font-Font-Size-h5, 16px) !important;\n  }\n\n  .faq-answer-test.ant-typography {\n    font-size: 15px !important;\n  }\n\n  .advertisement-link-faq {\n    font-size: 16px !important;\n    text-decoration: underline !important;\n  }\n}\n\n.enquiry-chat-description {\n  display: flex;\n  align-items: center !important;\n}\n\n.enquiry-billboard-chat-div.ant-float-btn {\n  bottom: 115px !important;\n}\n\n.enquiry-billboard-chat-div-mobile {\n  height: 70px;\n  width: 70px;\n  background-color: #fff;\n  border-top-left-radius: 40px;\n  border-bottom-left-radius: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 50%;\n  margin-right: 2%;\n}\n\n.enquiry-billboard-layout-mobile {\n  display: flex;\n  margin-top: -10%;\n  z-index: 100;\n  width: 100%;\n  justify-content: end;\n  position: fixed;\n  top: 51rem;\n  align-self: flex-start;\n}\n\n.segment-card-back-home {\n  display: flex;\n  padding: 0.625rem 1.0625rem;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 1rem;\n  flex-shrink: 0;\n}\n\n.segment-card-back-home.ant-card .ant-card-body {\n  padding: 0px !important;\n  border-radius: 0 0 8px 8px;\n}\n\n.segment-buyer-seller-component.ant-segmented .ant-segmented-item-selected {\n  background-color: #eaeaea;\n  color: rgba(0, 0, 0, 0.88);\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 1rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.ant-segmented.ant-segmented-lg .ant-segmented-item-label {\n  display: flex !important;\n  min-height: 45px !important;\n  line-height: 36px;\n  font-size: 19px;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 1rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  justify-content: center !important;\n}\n\n.home-page-segement-card {\n  background-color: transparent;\n  border-radius: 10px;\n}\n\n.home-page-segement-card .ant-segmented-group {\n  gap: 10px;\n  background: #fff;\n}\n\n.home-page-segment-roles.ant-segmented {\n  padding: 0.1px !important;\n}\n\n.home-page-segement-card.ant-card .ant-card-body {\n  padding: 12px !important;\n  background: #fff;\n}\n\n.home-page-segement-card .ant-segmented .ant-segmented-item {\n  background: #fff;\n}\n\n.home-page-segement-card .ant-segmented .ant-segmented-item-selected {\n  background: #f5f5f5;\n}\n\n.list-card {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.custom-card.ant-card .ant-card-body {\n  padding: 15px !important;\n}\n\n.custom-service-card .ant-card-body {\n  margin-top: 4rem;\n  position: relative;\n}\n\n.read-more {\n  margin-top: 20px;\n}\n\n.theme-red.ant-typography {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: 3.78rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 4rem;\n}\n\n.segment-buyer-seller-component .ant-segmented-item-label {\n  padding: 8px 20px !important;\n  align-items: center;\n  width: auto;\n  font-size: 16px;\n}\n\n.buyers-reach-description-text {\n  color: #000;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h6, 1.1875rem) !important;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.78125rem;\n}\n\n.join-marketplace-title.ant-typography {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h1, 48px);\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n  padding-top: 75px;\n  font-family: \"Roboto\";\n}\n\n.benefits-signup-text.ant-typography {\n  display: block;\n  position: relative;\n  height: 28px;\n  margin: 0 0 0 0;\n  color: #0a0f0d;\n  font-family: \"Roboto\";\n  font-size: 23px;\n  font-weight: 800;\n  line-height: 28px;\n  text-align: left;\n  white-space: nowrap;\n  margin-bottom: 10px;\n}\n\n@media (min-width: 1025px) and (max-width: 1440px) {\n  .desktop-view .ant-typography {\n    color: #ffffff;\n    margin-top: 1rem;\n    font-size: var(--Font-Font-Size-h5, 20px) !important;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 30.6px;\n    font-family: Roboto;\n  }\n\n  .segment-buyer-seller-component .ant-segmented-item-label {\n    padding: 8px 20px !important;\n    align-items: center;\n    width: auto;\n    font-size: 16px !important;\n  }\n\n  .create-accont-btn-signup.ant-btn-primary {\n    margin-top: 3.5em;\n    font-weight: 500;\n    color: #fff;\n    background-color: #d2042d;\n    padding: 20px 20px;\n    font-size: 16px;\n    height: 60px !important;\n  }\n\n  .action-btn {\n    background-color: #d2042d;\n    color: white;\n    border: none;\n    font-weight: 600;\n    width: 108px;\n    height: 50px;\n    margin-right: 20px;\n    font-size: 1rem;\n    border-radius: 0.3125rem;\n  }\n\n  .default-btn {\n    border-radius: 0.3125rem;\n    background: var(--Colors-Text-400, #3b3f3d);\n    color: white;\n    border: none;\n    font-weight: 600;\n    width: 108px;\n    height: 50px;\n    margin-right: 20px;\n    font-size: 1rem;\n  }\n\n  .location-title-name.ant-typography {\n    font-size: var(--Font-Font-Size-h4, 24px);\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .home-cont-title {\n    color: #fff !important;\n    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    font-family: \"Roboto\";\n    font-size: 40px !important;\n    font-style: normal;\n    font-weight: 900;\n    line-height: normal;\n    text-align: center;\n  }\n\n  .request-for-demo.ant-btn-variant-outlined:hover {\n    margin-top: 1.5rem !important;\n    height: 50px !important;\n  }\n}\n\n.enquiry-billboard-chat-div {\n  height: 70px;\n  width: 70px;\n  background-color: #d2042d;\n  display: flex;\n  margin-right: -25px;\n  align-items: center;\n  padding: 0 15px;\n  cursor: pointer;\n  overflow: hidden;\n  transition: width 0.3s ease;\n}\n\n.enquiry-billboard-chat-div.ant-float-btn .ant-float-btn-body {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  transition: all 0.2s;\n  align-items: stretch;\n  justify-content: flex-start;\n  flex-direction: row;\n}\n\n.enquiry-billboard-chat-div.ant-float-btn-circle {\n  border-top-left-radius: 40px !important;\n  border-bottom-left-radius: 40px !important;\n  border-bottom-right-radius: 0px !important;\n  border-top-right-radius: 0px !important;\n}\n\n.enquiry-billboard-chat-div.ant-float-btn\n  .ant-float-btn-body\n  .ant-float-btn-content\n  .ant-float-btn-icon {\n  text-align: center;\n  margin: auto;\n  width: 25px !important;\n  font-size: 18px;\n  line-height: 1;\n}\n\n.enquiry-billboard-chat-div.ant-float-btn\n  .ant-float-btn-body\n  .ant-float-btn-content {\n  overflow: visible !important;\n}\n\n.enquiry-icon {\n  flex-shrink: 0;\n}\n\n.enquiry-text {\n  opacity: 0;\n  visibility: hidden;\n  white-space: nowrap;\n  margin-left: 10px;\n  color: white;\n  font-weight: 600;\n  font-size: 19px;\n  transition: opacity 0.3s ease 0.1s;\n}\n\n.float-chat-enquiry-btn-home.ant-float-btn-circle {\n  width: 50px !important;\n  height: 50px !important;\n}\n\n.float-chat-enquiry-btn-common {\n  bottom: 90px !important;\n  right: 15px !important;\n  width: 50px !important;\n  height: 50px !important;\n}\n\n.float-chat-enquiry-btn-home.ant-float-btn\n  .ant-float-btn-body\n  .ant-float-btn-content\n  .ant-float-btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px !important;\n  height: 30px !important;\n}\n\n.float-chat-enquiry-btn-common.ant-float-btn\n  .ant-float-btn-body\n  .ant-float-btn-content\n  .ant-float-btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px !important;\n  height: 30px !important;\n}\n\n.home-calendar .ant-picker .ant-picker-input > input {\n  font-size: 14px !important;\n  font-family: Roboto !important;\n  color: #757575 !important;\n  font-weight: 400 !important;\n  line-height: 33.6px !important;\n  text-align: center !important;\n}\n\n@media (min-width: 426px) and (max-width: 768px) {\n  .location-item img {\n    width: 100% !important;\n    height: 100% !important;\n    border-radius: 8px;\n  }\n}\n\n@media (min-width: 768px) {\n  .enquiry-billboard-chat-div:hover {\n    width: 240px;\n  }\n\n  .enquiry-billboard-chat-div:hover .enquiry-text {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .float-chat-enquiry-btn-home.ant-float-btn-circle {\n    width: 60px !important;\n    height: 60px !important;\n  }\n\n  .float-chat-enquiry-btn-home.ant-float-btn-circle {\n    bottom: 100px !important;\n    right: 44px !important;\n  }\n\n  .float-chat-enquiry-btn-common.ant-float-btn-circle {\n    width: 60px !important;\n    height: 60px !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .enquiry-billboard-chat-div {\n    width: 240px;\n  }\n\n  .enquiry-text {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.space-component {\n  border-radius: 10px;\n  border-width: 1px;\n  background: #ffffff;\n  border: 1px solid var(--Colors-Text-100, #b3b5b4);\n  box-shadow: 2px 2px 30px 0px #0000000d;\n  width: 80% !important;\n}\n\n.home_input_search .ant-input-outlined {\n  border-style: none !important;\n}\n\n/* ========================================================\n   MAP + WE GET YOU EVERYWHERE\n   ======================================================== */\n.home-aligned-wrapper {\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 0 30px;\n}\n\n.home-aligned-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 80px;\n  row-gap: 30px;\n  align-items: center;\n}\n\n.section-bottom-space {\n  padding-top: 70px;\n  padding-bottom: 90px;\n}\n\n.home-grid-left,\n.home-grid-right,\n.locations-map-content {\n  width: 100%;\n  display: flex;\n  gap: 24px;\n  flex-direction: column;\n}\n\n/* <Text> in JSX, so display:block is required */\n.aligned-main-title {\n  display: block;\n  color: #0a0a0a;\n  font-family: Roboto, sans-serif;\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 1.15;\n  margin: 0 0 18px 0;\n  letter-spacing: -0.5px;\n}\n\n.aligned-main-title span {\n  color: #d2042d;\n}\n\n.aligned-description-text {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.65;\n  color: #4b5563;\n  margin-bottom: 28px;\n}\n\n/* .usa-map-image {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 12px;\n} */\n\n.map-cities-badge {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin: 14px 0 18px 0;\n}\n\n.cities-count {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 32px;\n  font-weight: 900;\n  color: #0a0a0a;\n}\n\n.cities-label {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: #4b5563;\n}\n\n.usa-statistics {\n  display: flex;\n  gap: 16px;\n  width: 100%;\n  /* same width as the map */\n}\n\n.usa-stat-card {\n  border-radius: 12px !important;\n  background: #ffffff !important;\n  border: 1px solid #f0f2f5 !important;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03) !important;\n  width: auto;\n  flex: 1 1 0;\n}\n\n.usa-stat-card .ant-card-body {\n  padding: 14px 18px !important;\n}\n\n.stat-card-inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.usa-stat-number {\n  display: block;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.1;\n  color: #d2042d;\n}\n\n.usa-stat-label {\n  display: block;\n  margin-top: 4px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.stat-card-icon {\n  font-size: 26px;\n  color: #d1d5db;\n}\n\n.locations-reach-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  /* was 62% */\n}\n\n.reach-subtext {\n  margin-bottom: 28px;\n}\n\n.reach-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.reach-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.reach-number {\n  min-width: 30px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #d2042d;\n  color: #ffffff;\n  border-radius: 4px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.reach-item-info {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.reach-item-title {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.3;\n}\n\n.reach-item-description {\n  margin-top: 3px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #6b7280;\n  line-height: 1.45;\n}\n\n.amp-reach-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4%;\n  width: 75%;\n  margin: 0 auto;\n  padding: 40px 0 100px;\n  box-sizing: border-box;\n}\n\n.amp-reach-section .amp-reach-left {\n  flex: 0 0 48%;\n  width: 48%;\n  min-width: 0;\n}\n\n.amp-reach-section .amp-reach-right {\n  flex: 0 0 48%;\n  width: 48%;\n  min-width: 0;\n}\n\n.amp-reach-section .amp-reach-right .aligned-main-title {\n  font-size: clamp(30px, 2.5vw, 48px);\n}\n\n.amp-reach-section .amp-reach-right .aligned-description-text {\n  font-size: clamp(13px, 0.83vw, 16px);\n}\n\n.amp-reach-section .reach-item-title {\n  font-size: clamp(14px, 0.94vw, 18px);\n}\n\n.amp-reach-section .reach-item-description {\n  font-size: clamp(12px, 0.75vw, 14px);\n}\n\n@media (max-width: 1024px) {\n  .amp-reach-section {\n    width: 84%;\n    margin: 0 auto;\n    padding: 30px 0 60px;\n    gap: 4%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n  }\n\n  .amp-reach-section .amp-reach-right {\n    flex: 0 0 48%;\n    width: 48%;\n    min-width: 0;\n  }\n\n  .amp-reach-section .amp-reach-left {\n    flex: 0 0 48%;\n    width: 48%;\n    min-width: 0;\n  }\n\n  .home-aligned-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .amp-reach-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 90%;\n    margin: 0 auto 50px;\n    gap: 32px;\n    padding: 40px 0;\n  }\n\n  .amp-reach-section .amp-reach-left,\n  .amp-reach-section .amp-reach-right {\n    flex: none;\n    width: 100%;\n    padding-left: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .amp-reach-section .amp-reach-right .aligned-main-title {\n    font-size: 32px !important;\n    line-height: 1.2;\n  }\n\n  .amp-reach-section .amp-reach-right .aligned-description-text,\n  .reach-subtext {\n    font-size: 16px !important;\n    line-height: 1.5;\n  }\n\n  .usa-statistics {\n    display: flex;\n    flex-direction: row;\n    gap: 14px;\n    width: 100%;\n  }\n\n  .usa-stat-card {\n    width: 50%;\n    flex: 1 1 0;\n  }\n\n  .usa-stat-number {\n    font-size: 19px !important;\n  }\n\n  .usa-stat-label {\n    font-size: 13px !important;\n  }\n\n  .reach-items-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n\n  .reach-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    width: 100%;\n  }\n\n  .reach-number {\n    font-size: 13px !important;\n  }\n\n  .reach-item-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 100%;\n  }\n\n  .amp-reach-section .reach-item-title {\n    font-size: 19px !important;\n    font-weight: 600;\n  }\n\n  .amp-reach-section .reach-item-description {\n    font-size: 16px !important;\n    line-height: 1.4;\n  }\n}\n\n@media (max-width: 480px) {\n  .home-aligned-wrapper {\n    padding: 0 16px;\n  }\n\n  .aligned-main-title {\n    font-size: 28px;\n  }\n\n  .usa-statistics {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n/* ========================================================\n   FORMAT TICKER (INFINITE SCROLLING MARQUEE)\n   ======================================================== */\n.format-ticker-section {\n  width: 100%;\n  height: 109px;\n  background-color: #d2042d;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  position: relative;\n  box-shadow: 0 4px 20px rgba(210, 4, 45, 0.15);\n}\n\n.format-ticker-track {\n  display: flex;\n  width: max-content;\n  align-items: center;\n  animation: ticker-scroll 25s linear infinite;\n  white-space: nowrap;\n}\n\n.format-ticker-track:hover {\n  animation-play-state: paused;\n}\n\n.format-ticker-item {\n  display: inline-flex;\n  align-items: center;\n  padding: 0 42px;\n}\n\n.format-ticker-item span {\n  font-family: \"Roboto\", \"Arial Black\", sans-serif;\n  font-size: 34px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  color: #ffffff;\n  text-transform: uppercase;\n  line-height: 1;\n  user-select: none;\n}\n\n@keyframes ticker-scroll {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(-50%);\n  }\n}\n\n@media (max-width: 1024px) {\n  .format-ticker-section {\n    height: 90px;\n  }\n\n  .format-ticker-item span {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 768px) {\n  .format-ticker-section {\n    width: 100%;\n    height: 75px;\n    display: flex;\n    align-items: center;\n  }\n\n  .format-ticker-item {\n    padding: 0 24px;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  .format-ticker-item span {\n    font-size: 19px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .format-ticker-section {\n    height: 60px;\n  }\n\n  .format-ticker-item {\n    padding: 0 16px;\n  }\n\n  .format-ticker-item span {\n    font-size: 18px;\n  }\n}\n\n/* ========================================================\n   MEDIA SHOWCASE (SEE AMP IN ACTION)\n   ======================================================== */\n.media-showcase-section {\n  width: 100%;\n  background: #ffffff;\n  padding-top: 88px;\n  padding-bottom: 45px;\n}\n\n.media-showcase-container {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n}\n\n.media-showcase-header {\n  width: 100%;\n  margin: 0 0 14px 0;\n  /* margin-left: 28%; */\n  /* display: flex; */\n  /* align-content: center; */\n  /* flex-direction: column; */\n}\n\n/* Two <Text> children: 1st = title, 2nd = subtitle */\n.media-showcase-header > .ant-typography {\n  display: block;\n  font-family: Roboto, sans-serif;\n}\n\n.media-showcase-header > .ant-typography:first-child {\n  margin: 0;\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.8px;\n  color: #080808;\n}\n\n.media-showcase-header > .ant-typography:first-child span {\n  color: #d2042d;\n}\n\n.media-showcase-header > .ant-typography:last-child {\n  margin: 8px 0 0 0;\n  font-size: 16px;\n  line-height: 1.4;\n  color: #4b5563;\n}\n\n.media-showcase-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 85%;\n  row-gap: 8%;\n  column-gap: 4%;\n  /* margin-left: 12%; */\n  flex-wrap: wrap;\n}\n\n.media-showcase-left {\n  width: 44%;\n  min-width: 0;\n}\n\n.media-showcase-right {\n  width: 40%;\n}\n\n.media-main-image-container {\n  position: relative;\n  width: 100%;\n  height: 380px;\n  overflow: hidden;\n  border-radius: 15px;\n  background: #eeeeee;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n}\n\n.media-main-image {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  transition: transform 0.25s ease;\n}\n\n.media-main-image-container:hover .media-main-image {\n  transform: scale(1.01);\n}\n\n.media-duration {\n  position: absolute;\n  top: 13px;\n  right: 13px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  border-radius: 12px;\n  background: rgba(31, 48, 67, 0.92);\n  color: #ffffff;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 10px;\n  font-weight: 500;\n  z-index: 5;\n}\n\n.media-main-overlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 55px 18px 19px;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75));\n  z-index: 3;\n}\n\n/* Two <Text> children: 1st = title, 2nd = description */\n.media-main-overlay > .ant-typography {\n  display: block;\n  font-family: Roboto, sans-serif;\n}\n\n.media-main-overlay > .ant-typography:first-child {\n  margin: 0 0 6px 0;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #ffffff;\n}\n\n.media-main-overlay > .ant-typography:last-child {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.88);\n}\n\n.media-bottom-controls {\n  width: 100%;\n  height: 30px;\n  margin-top: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.media-dots {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.media-dot {\n  display: block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #d4d8dd;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.media-dot.active {\n  width: 20px;\n  border-radius: 5px;\n  background: #d2042d;\n}\n\n.media-list-title {\n  height: 20px;\n  margin: 0 0 9px 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  color: #3f4348;\n}\n\n.media-image-list {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.media-image-card {\n  width: 100%;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 9px;\n  background: #ffffff;\n  border: 1px solid #eeeeee;\n  border-radius: 9px;\n  cursor: pointer;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s,\n    transform 0.2s;\n}\n\n.media-image-card:hover {\n  border-color: #d2042d;\n  transform: translateX(1px);\n}\n\n.media-image-card.active {\n  border: 2px solid #d2042d;\n  padding: 6px 8px;\n  box-shadow: 0 2px 8px rgba(210, 4, 45, 0.05);\n}\n\n.media-thumbnail {\n  width: 62px;\n  height: 46px;\n  flex-shrink: 0;\n  display: block;\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n.media-card-content {\n  min-width: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n}\n\n/* Red category label (plain <span>) */\n.media-card-content span {\n  display: block;\n  margin: 0 0 2px 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: #d2042d;\n}\n\n/* Title is a <Text>; this overrides the span rule above */\n.media-card-content .ant-typography {\n  display: block;\n  margin: 0;\n  overflow: hidden;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #20252b;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 1024px) {\n  .media-showcase-section {\n    width: 100%;\n    padding-top: 50px;\n    padding-bottom: 40px;\n  }\n\n  .media-showcase-container {\n    width: 96%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0 auto;\n    gap: 20px;\n  }\n  .media-showcase-content {\n    width: 100%;\n    grid-template-columns: 1fr;\n    row-gap: 24px;\n  }\n\n  .media-main-image-container {\n    height: 360px;\n  }\n}\n\n@media (max-width: 768px) {\n  .media-showcase-section {\n    width: 100%;\n    padding-top: 50px;\n    padding-bottom: 40px;\n  }\n\n  .media-showcase-container {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0 auto;\n    gap: 20px;\n  }\n\n  .media-showcase-header {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 14px;\n  }\n\n  .media-showcase-header > .ant-typography:first-child {\n    font-size: 32px !important;\n    line-height: 1.2;\n  }\n\n  .media-showcase-header > .ant-typography:last-child {\n    font-size: 16px !important;\n  }\n\n  .media-showcase-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  .media-showcase-left {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .media-main-image-container {\n    width: 100%;\n    height: 320px;\n  }\n\n  .media-duration {\n    font-size: 13px !important;\n  }\n\n  .media-main-overlay > .ant-typography:first-child {\n    font-size: 19px !important;\n  }\n\n  .media-main-overlay > .ant-typography:last-child {\n    font-size: 16px !important;\n  }\n\n  .media-showcase-right {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .media-list-title {\n    font-size: 19px !important;\n    font-weight: 600;\n  }\n\n  .media-image-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .media-image-card {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    height: 72px;\n    padding: 8px 12px;\n  }\n\n  .media-thumbnail {\n    width: 68px;\n    height: 50px;\n    flex-shrink: 0;\n  }\n\n  .media-card-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 2px;\n    width: 100%;\n  }\n\n  .media-card-content span {\n    font-size: 13px !important;\n  }\n\n  .media-card-content .ant-typography {\n    font-size: 19px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .media-showcase-header > .ant-typography:first-child {\n    font-size: 28px;\n  }\n\n  .media-showcase-header > .ant-typography:last-child {\n    font-size: 13px;\n  }\n\n  .media-main-image-container {\n    height: 240px;\n  }\n\n  .media-image-card {\n    height: 68px;\n  }\n\n  .media-thumbnail {\n    width: 60px;\n    height: 48px;\n  }\n}\n\n/* ========================================================\n   LET'S GET STARTED (BUYER / SELLER)\n   ======================================================== */\n.get-started-section {\n  width: 100%;\n  display: flex;\n  background: #ffffff;\n  padding: 62px 0 70px;\n  justify-content: center;\n}\n\n.get-started-container {\n  width: 75%;\n  display: flex;\n  flex-direction: column;\n  align-content: space-around !important;\n  flex-wrap: wrap;\n}\n\n.get-started-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 36px;\n}\n\n/* Two <Text> children: 1st = title, 2nd = subtitle */\n.get-started-heading > .ant-typography {\n  display: block;\n  font-family: Roboto, sans-serif;\n}\n\n.get-started-heading > .ant-typography:first-child {\n  margin: 0;\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -1px;\n  color: #080808;\n}\n\n.get-started-heading > .ant-typography:first-child span {\n  color: #d2042d;\n}\n\n.get-started-heading > .ant-typography:last-child {\n  margin: 9px 0 0;\n  font-size: 16px;\n  line-height: 1.4;\n  color: #4b5563;\n}\n\n.user-type-toggle {\n  width: 245px;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  padding: 3px;\n  background: #ffffff;\n  border: 1px solid #dedede;\n  border-radius: 9px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);\n}\n\n.user-type-button {\n  flex: 1;\n  height: 37px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #68707a;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.user-type-button.active {\n  background: #d2042d;\n  color: #ffffff;\n  box-shadow: 0 2px 5px rgba(210, 4, 45, 0.18);\n}\n\n.user-type-icon {\n  font-size: 12px;\n  line-height: 1;\n}\n\n.get-started-card {\n  width: 100%;\n  height: 472px;\n  display: flex;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid #e7e7e7;\n  border-radius: 18px;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);\n}\n\n.get-started-image {\n  position: relative;\n  width: 100%;\n  height: 471px;\n  overflow: hidden;\n  background: #eeeeee;\n}\n\n.get-started-image img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.get-started-content {\n  width: 100%;\n  height: 442px;\n  padding: 36px;\n  display: flex;\n  flex-direction: column;\n}\n\n.get-started-content-icon {\n  width: 52px;\n  height: 52px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 13px;\n  border-radius: 9px;\n  background: #fff0f3;\n  color: #d2042d;\n  font-size: 23px;\n  font-weight: 700;\n}\n\n/* Card title (\"I'm a Seller / Buyer\") is a <Text> */\n.get-started-content > .ant-typography {\n  display: block;\n  margin: 0 0 24px;\n  font-family: Roboto, sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #171717;\n}\n\n.get-started-description {\n  max-width: 500px;\n  margin: 0 0 25px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.9;\n  color: #606060;\n}\n\n.get-started-points {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-bottom: 28px;\n}\n\n.get-started-point {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  color: #374151;\n}\n\n.get-started-check {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #d2042d;\n  font-size: 20px;\n}\n\n.get-started-action-button {\n  width: 100%;\n  height: 43px;\n  margin-top: auto;\n  border: none;\n  border-radius: 5px;\n  background: #d2042d;\n  color: #ffffff;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.get-started-action-button:hover {\n  background: #b50326;\n}\n\n.get-started-arrow {\n  margin-left: 6px;\n  font-size: 17px;\n}\n\n@media (max-width: 1024px) {\n  .get-started-section {\n    width: 100%;\n    display: flex;\n    background: #ffffff;\n    padding: 62px 0 70px;\n    justify-content: center;\n  }\n  .get-started-container {\n    width: 80%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 24px;\n  }\n\n  .get-started-header {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .get-started-card {\n    height: auto;\n    grid-template-columns: 1fr;\n  }\n\n  .get-started-image {\n    height: 350px;\n  }\n\n  .get-started-content {\n    height: auto;\n    min-height: 400px;\n  }\n}\n\n@media (max-width: 768px) {\n  .get-started-section {\n    width: 100%;\n    padding: 50px 0;\n    display: flex;\n    justify-content: center;\n  }\n\n  .get-started-container {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 24px;\n  }\n\n  .get-started-header {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n    margin-bottom: 20px;\n  }\n\n  .get-started-heading > .ant-typography:first-child {\n    font-size: 32px !important;\n    line-height: 1.2;\n  }\n\n  .get-started-heading > .ant-typography:last-child {\n    font-size: 16px !important;\n  }\n\n  .user-type-toggle {\n    width: 100%;\n    display: flex;\n    gap: 8px;\n  }\n\n  .user-type-button {\n    font-size: 16px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n  }\n\n  .get-started-card {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: auto;\n    border-radius: 14px;\n    overflow: hidden;\n  }\n\n  .get-started-image {\n    width: 100%;\n    height: 280px;\n  }\n\n  .get-started-content {\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 24px;\n  }\n\n  .get-started-content > .ant-typography {\n    font-size: 19px !important;\n    margin: 0 0 10px 0;\n  }\n\n  .get-started-description {\n    font-size: 16px !important;\n    line-height: 1.6;\n    margin: 0 0 14px 0;\n  }\n\n  .get-started-points {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    margin-bottom: 20px;\n  }\n\n  .get-started-point {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 16px !important;\n  }\n\n  .get-started-action-button,\n  .get-started-content .rtgs-btn {\n    width: 100%;\n    height: 48px;\n    font-size: 16px !important;\n  }\n\n  .get-started-arrow {\n    font-size: 16px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .get-started-section {\n    padding: 40px 0;\n  }\n\n  .get-started-heading > .ant-typography:first-child {\n    font-size: 28px;\n  }\n\n  .get-started-image {\n    height: 240px;\n  }\n\n  .get-started-content {\n    padding: 24px 18px;\n  }\n}\n\n/* ========================================================\n   WHAT OUR CLIENTS SAY (TESTIMONIALS)\n   (h2 and p are still real tags in the JSX, so unchanged)\n   ======================================================== */\n.testimonials-section {\n  width: 100%;\n  background: #000000;\n  padding: 80px 0 90px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.testimonials-container {\n  width: 75%;\n}\n\n.testimonials-title {\n  margin: 0 0 56px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 1.15;\n  color: #ffffff;\n  text-transform: uppercase;\n}\n\n.testimonials-title span {\n  color: #d2042d;\n}\n\n.testimonials-grid {\n  display: flex;\n  gap: 40px;\n}\n\n.testimonial-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 24px;\n  min-height: 240px;\n  padding: 32px;\n  background: #1f1f1f;\n  border-radius: 10px;\n}\n\n.testimonial-quote {\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.55;\n  color: #ffffff;\n}\n\n.testimonial-author {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-top: 20px;\n  border-top: 1px solid #3a3a3a;\n}\n\n.testimonial-name {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n  color: #ffffff;\n}\n\n.testimonial-role {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #9ca3af;\n}\n\n@media (max-width: 1024px) {\n  .testimonials-section {\n    width: 100%;\n    padding: 50px 0 60px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .testimonials-container {\n    width: 80%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  .testimonials-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .testimonial-card {\n    min-height: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .testimonials-section {\n    width: 100%;\n    padding: 50px 0 60px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .testimonials-container {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .testimonials-title {\n    font-size: 32px;\n    margin-bottom: 24px;\n    line-height: 1.2;\n  }\n\n  .testimonials-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n\n  .testimonial-card {\n    width: 100%;\n    min-height: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 20px;\n    border-radius: 10px;\n  }\n\n  .testimonial-quote {\n    font-size: 16px !important;\n    line-height: 1.6;\n  }\n\n  .testimonial-author {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding-top: 14px;\n    width: 100%;\n  }\n\n  .testimonial-name {\n    font-size: 19px !important;\n    font-weight: 600;\n  }\n\n  .testimonial-role {\n    font-size: 13px !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .testimonials-section {\n    padding: 50px 0 60px;\n  }\n\n  .testimonials-title {\n    font-size: 29px;\n    margin-bottom: 36px;\n  }\n}\n\n/* ========================================================\n   FREQUENTLY ASKED QUESTIONS (FAQ)\n   ======================================================== */\n.home-faq-section {\n  width: 100%;\n  background: #ffffff;\n  padding: 80px 0 90px;\n}\n\n.home-faq-container {\n  width: 75%;\n  max-width: calc(100% - 40px);\n  margin: 0 auto;\n}\n\n.home-faq-title {\n  margin: 0 0 40px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 1.15;\n  color: #080808;\n  text-transform: uppercase;\n}\n\n.home-faq-title span {\n  color: #d2042d;\n}\n\n.home-faq-list {\n  width: 100%;\n}\n\n.home-faq-item {\n  border-bottom: 1px solid #ececec;\n}\n\n.home-faq-question {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 28px 40px 28px 0;\n  border: none;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #0a0a0a;\n}\n\n.home-faq-icon {\n  position: relative;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.home-faq-icon::before,\n.home-faq-icon::after {\n  content: \"\";\n  position: absolute;\n  background: #0a0a0a;\n  transition: transform 0.25s ease;\n}\n\n.home-faq-icon::before {\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 1.5px;\n  transform: translateY(-50%);\n}\n\n.home-faq-icon::after {\n  top: 0;\n  left: 50%;\n  width: 1.5px;\n  height: 100%;\n  transform: translateX(-50%);\n}\n\n.home-faq-item.open .home-faq-icon::after {\n  transform: translateX(-50%) scaleY(0);\n}\n\n.home-faq-answer-wrap {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.3s ease;\n}\n\n.home-faq-item.open .home-faq-answer-wrap {\n  grid-template-rows: 1fr;\n}\n\n.home-faq-answer-inner {\n  overflow: hidden;\n}\n\n.home-faq-answer {\n  margin: 0;\n  padding: 0 40px 28px 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.75;\n  color: #5b6270;\n}\n\n.home-faq-more {\n  display: flex;\n  justify-content: center;\n  margin-top: 56px;\n}\n\n.home-faq-more-button {\n  width: 170px;\n  height: 50px;\n  border: none;\n  border-radius: 8px;\n  background: #d2042d;\n  color: #ffffff;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.home-faq-more-button:hover {\n  background: #b50326;\n}\n@media (max-width: 1024px) {\n  .home-faq-section {\n    width: 100%;\n    padding: 50px 0 60px;\n  }\n\n  .home-faq-container {\n    width: 80%;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .home-faq-section {\n    width: 100%;\n    padding: 50px 0 60px;\n  }\n\n  .home-faq-container {\n    width: 90%;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    margin: 0 auto;\n  }\n\n  .home-faq-title {\n    font-size: 32px;\n    margin-bottom: 20px;\n    line-height: 1.2;\n  }\n\n  .home-faq-list {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .home-faq-item {\n    width: 100%;\n  }\n\n  .home-faq-question {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    width: 100%;\n    padding: 18px 0;\n    font-size: 19px !important;\n    line-height: 1.35;\n  }\n\n  .home-faq-answer,\n  .faq-answer-test,\n  .home-faq-answer-inner .ant-typography {\n    padding-right: 0;\n    font-size: 16px !important;\n    line-height: 1.6;\n  }\n\n  .home-faq-more {\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n    width: 100%;\n  }\n\n  .home-faq-more-button {\n    font-size: 16px !important;\n    height: 48px;\n    width: 170px;\n  }\n}\n\n/* ========================================================\n   READY TO GET STARTED (RTGS)\n   ======================================================== */\n.rtgs {\n  width: 100%;\n  background-color: #050505;\n  padding: 95px 20px 105px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.rtgs-inner {\n  text-align: center;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.rtgs-text {\n  color: #ffffff;\n  font-size: 48px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  margin: 0 0 16px 0;\n  line-height: 1.15;\n  text-align: center;\n}\n\n.rtgs-para {\n  color: #e5e7eb;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 1.5;\n  max-width: 740px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.rtgs-btn-comp {\n  margin-top: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 22px;\n  flex-wrap: wrap;\n}\n\n.rtgs-btn {\n  min-width: 185px;\n  height: 45px;\n  padding: 0 26px;\n  border: none;\n  border-radius: 8px;\n  background: #d2042d !important;\n  color: #ffffff;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 0.2s ease,\n    transform 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rtgs-btn:hover {\n  background: #b50326;\n  transform: translateY(-1px);\n}\n\n.rtgs-features,\n.rtgs-last {\n  margin-top: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 40px;\n  flex-wrap: wrap;\n}\n\n.rtgs-feature-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  color: #e5e7eb;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.rtgs-check-icon {\n  font-size: 16px;\n  color: #ffffff;\n}\n\n@media (max-width: 768px) {\n  .rtgs {\n    width: 100%;\n    padding: 60px 20px 70px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .rtgs-inner {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    text-align: center;\n  }\n\n  .rtgs-text {\n    font-size: 32px;\n    line-height: 1.2;\n  }\n\n  .rtgs-para {\n    font-size: 16px !important;\n    line-height: 1.5;\n  }\n\n  .rtgs-btn-comp {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 14px;\n    align-items: center;\n    margin-top: 28px;\n  }\n\n  .rtgs-btn {\n    width: 100%;\n    max-width: 280px;\n    height: 48px;\n    font-size: 16px !important;\n  }\n\n  .rtgs-features,\n  .rtgs-last {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    align-items: center;\n    width: 100%;\n    margin-top: 24px;\n  }\n\n  .rtgs-feature-item {\n    font-size: 13px !important;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  }\n}\n\n/* ========================================================\n   SEARCH BILLBOARD ADVERTISING ACROSS THE COUNTRY\n   ======================================================== */\n.country-search-section {\n  width: 100%;\n  background: #ffffff;\n  padding: 65px 0 75px;\n}\n\n.country-search-container {\n  width: 75%;\n  max-width: calc(100% - 40px);\n  margin: 0 auto;\n  text-align: left;\n}\n\n/* <Text> in JSX, so display:block is required */\n.country-search-title {\n  display: block;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-style: normal;\n  font-size: var(--Font-Font-Size-h6, 20px);\n  line-height: 20px;\n  letter-spacing: 0px;\n  color: #0a0a0a;\n  margin: 0 0 8px 0;\n}\n\n.country-search-subtitle {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0px;\n  color: #757575;\n  margin: 0 0 34px 0;\n}\n\n.country-search-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 30px;\n}\n\n.country-search-column {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.country-search-link {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: #d2042d !important;\n  text-decoration: underline !important;\n  transition:\n    opacity 0.2s ease,\n    color 0.2s ease;\n  cursor: pointer;\n  display: inline-block;\n  width: fit-content;\n}\n\n.country-search-link:hover {\n  color: #b50326 !important;\n  opacity: 0.85;\n}\n\n@media (max-width: 1024px) {\n  .country-search-section {\n    width: 100%;\n    background: #ffffff;\n    padding: 65px 0 75px;\n  }\n\n  .country-search-container {\n    width: 80%;\n    max-width: calc(100% - 40px);\n    margin: 0 auto;\n    text-align: left;\n  }\n\n  .country-search-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .country-search-section {\n    width: 100%;\n    padding: 45px 0 50px;\n  }\n\n  .country-search-container {\n    width: 90%;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin: 0 auto;\n  }\n\n  .country-search-title {\n    font-size: 19px !important;\n    line-height: 1.3;\n    margin-bottom: 6px;\n  }\n\n  .country-search-subtitle {\n    font-size: 16px !important;\n    line-height: 1.5;\n    margin-bottom: 20px;\n  }\n\n  .country-search-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n  }\n\n  .country-search-column {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .country-search-link {\n    font-size: 16px !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .country-search-section {\n    padding: 45px 0 50px;\n  }\n\n  .country-search-grid {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n}\n.image-above-footer {\n  width: 100%;\n}\n.footer-image {\n  width: 100%;\n  height: max-content;\n  margin-bottom: -4px;\n}\n/* @media screen and (max-width: 768px) {\n  .image-above-footer {\n    width: 100%;\n    margin-bottom: 0;\n    overflow: hidden;\n    line-height: 0;\n  }\n\n  .footer-image {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
